// Eshop:

// {{{ Eshop specific overrides

GW.override(GW.Component, {
	'after:initObject'() {
		if (this.onDataChange) {
			this.onDataChange(Eshop.DataStore.changesAll);
		}
	},
});

// }}}

// Widgets for eshop:

// {{{ Eshop.MessageDialog

GW.define('Eshop.MessageDialog', 'GW.Component', {
	paragraphs: [],

	confirmText: null,
	cancelText: null,

	initComponent() {
		this.promise = Utils.makeCompleter();

		this.el = document.gwCreateElement({
			className: 'message-dialog',
			children: [{
				className: 'close',
				children: [Utils.useIcon('close')],
				'on:click': ev => this.close(),
			}, ...this.paragraphs.map(text => ({
				nodeName: 'p',
				textContent: text,
			})), {
				':skip': !this.confirmText,
				nodeName: 'button',
				textContent: this.confirmText,
				className: 'primary',
				'on:click': ev => this.onConfirm(),
			}, {
				':skip': !this.cancelText,
				nodeName: 'button',
				textContent: this.cancelText,
				className: 'tertiary',
				'on:click': ev => this.onCancel(),
			}],
		}, this);
	},

	onConfirm() {
		this.promise.resolve();
	},

	onCancel() {
		this.close();
	},

	close() {
		Application.closeOver();
		this.destroy();
	},
});

// }}}
// {{{ Eshop.ModalConfirmDialog

GW.define('Eshop.ModalConfirmDialog', 'GW.Component', {
	closeable: true,
	promptText: '',

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'dialog-mask ' + (this.cls || ''),
			tabIndex: '-1',
			$key_Escape: () => {
				if (this.closeable) {
					PopupManager.hideDownTo(this);
					PopupManager.hide(this);
				}
			},
			children: [this.renderDialog()],
		}, this);

		PopupManager.show(this, {
			noLayout: true,
			ignoreScroll: true,
			disableMobileUIPopover: true,
		});

		this.el.focus();
	},

	renderDialog() {
		return {
			ref: 'dialogEl',
			className: 'dialog',
			children: [{
				nodeName: 'h1',
				textContent: this.promptText,
			}, {
				className: 'buttons',
				children: [{
					nodeName: 'button',
					className: 'tertiary',
					textContent: _('Ano'),
					'on:click': ev => {
						this.onConfirm();
						this.destroy();
					},
				}, {
					nodeName: 'button',
					className: 'tertiary',
					textContent: _('Ne'),
					'on:click': ev => {
						this.onCancel();
						this.destroy();
					},
				}],
			}],
		};
	},

	onConfirm() {
	},

	onCancel() {
	},
});

// }}}
// {{{ Eshop.CartQtyChooser

GW.define('Eshop.CartQtyChooser', 'GW.Component', {
	value: 0,
	min: 0,
	max: 10000,
	product: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'cart-qty-chooser',
			children: [{
				ref: 'minusBtn',
				nodeName: 'button',
				className: 'tertiary icon-center hidden',
				children: [Utils.useIcon('minus')],
				'on:click': ev => this.onRemove(),
			}, {
				ref: 'qtyEl',
				className: 'qty hidden',
				textContent: '0x',
			}, {
				ref: 'plusBtn',
				nodeName: 'button',
				className: 'secondary icon-center hidden',
				children: [Utils.useIcon('plus')],
				'on:click': ev => this.onAdd(),
			}, {
				ref: 'addBtn',
				nodeName: 'button',
				className: 'secondary',
				textContent: _('Do košíku'),
				'on:click': ev => this.onAdd(),
			}],
		}, this);

		this.refresh();
	},

	onAdd() {
		let val = this.getValue();
		if (val < this.max) {
			Eshop.DataStore.setCartItem(this.product, val + 1);

			if (val + 1 == this.max) {
				Application.notify({
					kind: 'info',
					text: _('Přidali jste do košíku poslední volný kus'),
					priority: 10,
					exclusive: 'last-stock-item',
					timeout: 2000,
				});
			}
		}
	},

	onRemove() {
		let newVal, curVal = this.getValue();

		if (curVal > this.max) {
			newVal = this.max;
		} else if (curVal > this.min) {
			newVal = curVal - 1;
		}

		if (newVal != null) {
			Eshop.DataStore.setCartItemCheckDeps(this.product, newVal);
		}
	},

	refresh() {
		let v = this.value = Eshop.DataStore.getCartItemQty(this.product.id);
		this.max = Eshop.DataStore.getProductStock(this.product.id);

		this.qtyEl.textContent = v + 'x';
		this.minusBtn.classList.toggle('hidden', v == 0);
		this.plusBtn.classList.toggle('hidden', v == 0);
		this.qtyEl.classList.toggle('hidden', v == 0);
		this.addBtn.classList.toggle('hidden', v > 0);

		this.qtyEl.classList.toggle('out-of-range', v > this.max || v < this.min);
		this.addBtn.textContent = this.max > 0 ? _('Do košíku') : _('Není skladem');

		this.minusBtn.disabled = v <= this.min || this.disabled;
		this.plusBtn.disabled = v >= this.max || this.disabled;
		this.addBtn.disabled = v >= this.max || this.disabled;
	},

	setDisabled(v) {
		this.disabled = !!v;
		this.refresh();
	},

	setMax(v) {
		this.max = v;
		this.refresh();
	},

	setValue(v) {
		this.value = v;
		this.refresh();
	},

	getValue() {
		return this.value;
	},

	onDataChange(changes) {
		if (changes.anyOf('cart')) {
			this.setValue(Eshop.DataStore.getCartItemQty(this.product.id));
		}
	},
});

// }}}
// {{{ Eshop.CartButton

GW.define('Eshop.CartButton', 'GW.Component', {
	value: 0,

	initComponent() {
		this.el = document.gwCreateElement({
			nodeName: 'button',
			className: 'cart-button transparent icon-center',
			children: [Utils.useIcon('cart'), {
				className: 'qty hidden',
				ref: 'qtyEl',
			}],
			'on:click': ev => this.fire('click'),
		}, this);
	},

	refresh() {
		let v = this.value;

		this.qtyEl.classList.toggle('hidden', v == 0);
		this.qtyEl.textContent = v;
	},

	setValue(v) {
		this.value = v;
		this.refresh();
	},

	getValue() {
		return this.value;
	},
});

// }}}
// {{{ Eshop.LocationInput

GW.define('Eshop.LocationInput', 'GW.Component', {
	initComponent() {
		this.input = document.gwCreateElement({
			nodeName: 'input',
			placeholder: _('Zadejte číslo popisné a ulici či obec'),
			'on:focus': ev => {
				ev.target.select();

				this.askLocationHint();

				if (!this.selectedAddress && (this.position || ev.target.value.trim())) {
					this.loadSuggestions();
				}

				if (Application.isMobileUI()) {
					let el = ev.target;
					Utils.scrollIntoView(el);
					setTimeout(() => Utils.scrollIntoView(el), 1000);
				}
			},
			'on:blur': ev => {
				this.setValue(this.selectedAddress);
				this.input.blur();
			},
			'on:input': ev => {
                                this.selectedAddress = null;

				let query = this.input.value.trim();
				if (query || this.position) {
					this.loadSuggestions();
				} else {
					this.hideSuggestions();
				}
			},
			'on:keydown': ev => {
				let el;

				switch (ev.key) {
				case 'ArrowDown': 
					ev.preventDefault();
					el = this.suggestionsCt.querySelector('.selected');
					el = el && el.nextElementSibling;
					el = el || this.suggestionsCt.querySelector('.suggestion');

					if (el && el.matches('.suggestion')) {
						Utils.selectListItem(this.suggestionsCt, '.suggestion', 'selected', i => i === el);

						if (Application.isMobileUI()) {
							Utils.scrollIntoView(el);
						} else {
							if (el.offsetTop + el.offsetHeight > this.suggestionsCt.clientHeight + this.suggestionsCt.scrollTop) {
								this.suggestionsCt.scrollTop = el.offsetTop + el.offsetHeight - this.suggestionsCt.clientHeight;
							}
						}
					}
					break;
				case 'ArrowUp': 
					ev.preventDefault();
					el = this.suggestionsCt.querySelector('.selected');
					el = el && el.previousElementSibling;

					if (el && el.matches('.suggestion')) {
						Utils.selectListItem(this.suggestionsCt, '.suggestion', 'selected', i => i === el);

						if (Application.isMobileUI()) {
							Utils.scrollIntoView(el);
						} else {
							if (el.offsetTop < this.suggestionsCt.scrollTop) {
								this.suggestionsCt.scrollTop = el.offsetTop;
							}
						}
					}
					break;
				case 'Enter': 
					el = this.suggestionsCt.querySelector('.selected');
					if (el) {
						ev.preventDefault();
						this.setValue(el.$addr);
						this.input.select();
					}
					break;
				case 'Escape': 
					ev.preventDefault();
					this.clearValue();
					break;
				}
			},
		}, this);

		this.el = document.gwCreateElement({
			children: [this.input, {
				ref: 'suggestionsCt',
				className: 'location-suggestions-list hidden',
				'on*:mousedown': ev => {
					let s = ev.target.closest('.suggestion');
					if (s) {
						this.setValue(s.$addr);
					}
				},
			}, {
				nodeName: 'button',
				className: 'primary',
				textContent: _('Zobrazit nabídku'),
				'on:click': ev => {
					if (this.selectedAddress) {
						this.fire('select', this.selectedAddress);
						this.clearValue();
					} else {
						this.input.focus();
					}
				},
			}],
		}, this);
	},

	'before:releaseComponent'() {
		Utils.abort(this, 'suggest');
	},

	setValue(address) {
		this.input.value = address ? Formats.address(address) : '';
		this.selectedAddress = address;
		this.hideSuggestions();
		this.fire('change');
	},

	clearValue() {
		this.setValue(null);
	},

	getValue() {
		return this.selectedAddress;
	},

	askLocationHint() {
		if (this.asked) {
			return;
		}

		this.asked = true;

		navigator.geolocation.getCurrentPosition(position => {
			this.position = {
				lat: position.coords.latitude,
				lon: position.coords.longitude,
				accuracy: position.coords.accuracy,
			};

			if (Utils.isFocussed(this.input)) {
				this.loadSuggestions();
			}
		}, err => {
			if (err.code == GeolocationPositionError.POSITION_UNAVAILABLE) {
				Application.notify({
					kind: 'error',
					text: _('Informace o Vaší pozici není dostupná. Nemůžeme Vám nabídnout seznam blízkých adres.'),
					exclusive: 'no-location',
					timeout: 3000,
				});
			}
		}, {
			maximumAge: 1000 * 60 * 60 * 2,
			enableHighAccuracy: false,
		});
	},

	renderSuggestions(addresses, query) {
		this.suggestionsCt.textContent = '';

		if (!query) {
			this.suggestionsCt.gwCreateChild({
				className: 'header',
				textContent: _('Adresy ve Vašem okolí'),
			});
		} else if (0) {
			let parts = query.split(/[^\p{Letter}\p{Number}+]/u).filter(v => v !== '');
			let hasNum = parts.some(p => p.match(/^\d+$/));
			if (!hasNum) {
				this.suggestionsCt.gwCreateChild({
					className: 'header',
					textContent: _('Je nutné zadat číslo popisné'),
				});
				return;
			}
		}

		for (let a of addresses) {
			let fa = Formats.address_parts(a);

			this.suggestionsCt.gwCreateChild({
				$addr: a,
				className: 'suggestion',
				children: [{
					children: [{
						nodeName: 'span',
						className: 'ulice',
						textContent: fa.street + ', ',
					}, {
						nodeName: 'span',
						className: 'psc',
						textContent: fa.post_code + ' ' + fa.city,
					}]
				}, {
					children: [{
						nodeName: 'span',
						className: 'okres',
						textContent: '(' + [a.cast_obce, a.okres].filter(v => v).join(', ') + ')',
					}]
				}],
			});
		}

		if (addresses.length == 0) {
			this.suggestionsCt.gwCreateChild({
				className: 'empty',
				textContent: _('Adresa nenalezena'),
			});
		} else if (query) {
			QueryHighlighter.highlight(this.suggestionsCt, query);
		}

		if (!Application.isMobileUI()) {
			document.body.appendChild(this.suggestionsCt);
			Object.assign(this.suggestionsCt.style, {
				width: this.input.offsetWidth + 'px',
				top: (this.input.getBoundingClientRect().bottom + document.documentElement.scrollTop) + 'px',
				left: this.input.getBoundingClientRect().left + 'px',
				position: 'absolute',
			});
		}

		this.suggestionsCt.classList.remove('hidden');
		this.suggestionsCt.scrollTop = 0;
	},

	hideSuggestions() {
		Utils.abort(this, 'suggest');

		this.suggestionsCt.textContent = '';
		this.suggestionsCt.classList.add('hidden');
	},

	async loadSuggestions() {
		try {
			let query = this.input.value.trim();
			let abortSignal = Utils.abortAndRetry(this, 'suggest');
			let addresses = await REST.GET('/api/addresses/search', {
				q: query,
				...this.position,
			}, {abortSignal});

			this.renderSuggestions(addresses, query);
		} catch (ex) {
			if (ex instanceof AbortError) {
				return;
			}

			this.hideSuggestions();
			throw ex;
		}
	},
});

// }}}

// Landing page/address selection:

// {{{ Eshop.LandingMenuScreen

GW.define('Eshop.LandingMenuScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'landing-menu-screen',
			children: [{
				nodeName: 'header',
				children: [{
					xtype: 'AppLogo',
				}, {
					nodeName: 'button',
					className: 'transparent icon-center close',
					children: [Utils.useIcon('close')],
					'on:click': ev => {
						this.destroy();
					},
				}],
			}, {
				':skip': true,
				className: 'buttons',
				children: [{
					nodeName: 'button',
					className: 'secondary',
					textContent: _('Registrovat'),
				}, {
					nodeName: 'button',
					className: 'tertiary',
					textContent: _('Přihlásit'),
				}],
			}, {
				className: 'links',
				'on*:click': ev => {
					if (ev.target.closest('a')) {
						this.destroy();
					}
				},
				children: [{
					className: 'selected',
					nodeName: 'a',
					href: '#intro',
					textContent: _('Úvod'),
				}, {
					nodeName: 'a',
					href: '#services',
					textContent: _('Přehled služeb'),
				}, {
					nodeName: 'a',
					href: '#faq',
					textContent: _('Časté dotazy'),
				}, {
					nodeName: 'a',
					href: '/spoluprace',
					textContent: _('Spolupráce'),
				}, {
					nodeName: 'a',
					href: '#contact',
					textContent: _('Kontakt'),
				}],
			}],
		}, this);
	},
});

// }}}
// {{{ Eshop.LandingPage

GW.define('Eshop.LandingPage', 'GW.Component', {
	nativeDesktop: true,

	initComponent() {
		function picture(imgPath, config = {}) {
			return {
				nodeName: 'picture',
				...config,
				children: [{
					nodeName: 'source',
					type: 'image/webp',
					srcset: imgPath + '-1x.webp 1x, ' + imgPath + '-2x.webp 2x',
				}, {
					nodeName: 'source',
					type: 'image/png',
					srcset: imgPath + '-1x.png 1x, ' + imgPath + '-2x.png 2x',
				}, {
					// if we put src/srcset here, Safari
					// will load it in addition to the
					// preferred source from above (wth?)
					nodeName: 'img',
					...config,
				}],
			};
		}

		function normalSection({title, description, image, imageConfig, trail, cls, id}) {
			return {
				id,
				nodeName: 'section',
				className: cls,
				children: [{
					className: 'wrap',
					children: [{
						className: 'topimage',
						children: [picture('/imgs/landing/' + image, imageConfig)],
					}, {
						className: 'content',
						children: [{
							nodeName: 'h2',
							textContent: title,
						}, {
							nodeName: 'p',
							textContent: description,
						}, trail],
					}],
				}],
			};
		}

		this.el = document.gwCreateElement({
			id: 'top',
			className: 'landing-page',
			children: [{
				nodeName: 'header',
				children: [{
					className: 'wrap',
					children: [{
						nodeName: 'nav',
						children: [{
							xtype: 'AppLogo',
							href: '#top',
						}, {
							className: 'menu desktop',
							children: [{
								className: 'selected',
								nodeName: 'a',
								href: '#intro',
								textContent: _('Úvod'),
							}, {
								nodeName: 'a',
								href: '#services',
								textContent: _('Přehled služeb'),
							}, {
								nodeName: 'a',
								href: '#faq',
								textContent: _('Časté dotazy'),
							}, {
								nodeName: 'a',
								href: '/spoluprace',
								textContent: _('Spolupráce'),
							}, {
								nodeName: 'a',
								href: '#contact',
								textContent: _('Kontakt'),
							}, {
								':skip': true,
								nodeName: 'button',
								className: 'secondary',
								textContent: _('Registrovat'),
							}, {
								':skip': true,
								nodeName: 'button',
								className: 'tertiary',
								textContent: _('Přihlásit'),
							}]
						}, {
							nodeName: 'button',
							className: 'transparent icon-center mobile burger',
							children: [Utils.useIcon('menu')],
							'on:click': ev => {
								Application.showOver(new Eshop.LandingMenuScreen());
							},
						}]
					}],
				}],
			}, {
				nodeName: 'section',
				id: 'intro',
				className: 'intro',
				children: [{
					className: 'wrap',
					children: [{
						className: 'mobile stockimg',
						nodeName: 'img',
						src: '/imgs/friends.jpg',
						width: '375',
						height: '363',
					}, picture('/imgs/landing/top', {
						className: 'desktop stockimg',
						width: '900',
						height: '440',
					}), {
						nodeName: 'h1',
						textContent: _('Alkohol rychle až\xa0k\xa0Vašim dveřím'),
					}, {
						xtype: 'Eshop.LocationInput',
						'on:change': c => {
							if (c.getValue() && Application.isMobileUI()) {
								document.scrollingElement.scrollTo(0,
									c.el.getBoundingClientRect().top + document.scrollingElement.scrollTop - 100);
							}
						},
						'on:select': (c, address) => {
							this.selectWarehouse(address);
						},
					}],
				}],
			},

			...[{
				id: 'services',
				cls: 'large s1',
				image: 's1',
				imageConfig: {
					width: '544',
					height: '668',
				},
				title: _('Rychlý rozvoz nápojů až k Vám domů'),
				description: _('V noci, o víkendu, o svátcích. Jsme tu pro vás když ostatní mají zavřeno.'),
			}, {
				cls: 'grey',
				image: 's2',
				imageConfig: {
					width: '300',
					height: '540',
				},
				title: _('Expresní doručení v\xa0nejkratším možném čase'),
				description: _('Party v plném proudu, ale zásoby docházejí? Není problém!'),
			}, {
				cls: 'large s3',
				image: 's3',
				imageConfig: {
					width: '296',
					height: '532',
				},
				title: _('Pivo, víno, vodku a nebo třeba nějaké občerstvení?'),
				description: _('Vyberte si znaší široké nabídky, kterou pro vás neustále rozšiřujeme.'),
				trail: {
					className: 'products-image',
					children: [picture('/imgs/landing/pd', {
						width: '790',
						height: '280',
					}), {
						className: 'mask-left',
					}, {
						className: 'mask-right',
					}],
				},
			}, {
				cls: 'grey',
				image: 's5',
				imageConfig: {
					width: '296',
					height: '532',
				},
				title: _('Platba kartou online nebo hotově při převzetí'),
				description: _('Při platbě kartou vracíme 5 % z ceny formou slevového voucheru na další nákup.'),
			}, {
				cls: 'map',
				image: 'map',
				imageConfig: {
					width: '573',
					height: '373',
				},
				title: _('Rozvoz alkoholu Čáslav, Olomouc a Praha'),
			}].map(normalSection),

			{
				nodeName: 'section',
				className: 'select-location2',
				children: [{
					className: 'wrap',
					children: [{
						nodeName: 'h2',
						textContent: _('Tak co to bude?'),
					}, {
						xtype: 'Eshop.LocationInput',
						'on:change': c => {
							if (c.getValue() && Application.isMobileUI()) {
								document.scrollingElement.scrollTo(0,
									c.el.getBoundingClientRect().top + document.scrollingElement.scrollTop - 100);
							}
						},
						'on:select': (c, address) => {
							this.selectWarehouse(address);
						},
					}],
				}],
			}, {
				id: 'faq',
				nodeName: 'section',
				className: 'faq',
				children: [{
					className: 'wrap',
					children: [{
						nodeName: 'h2',
						textContent: _('Často se nás ptáte'),
					}, ...[
						[_('Kolik mě bude stát doprava?'), _('Cena dopravy je vypočítána na základě vzdálenosti mezi zákazníkem a výdejním skladem, tudíž se při každé objednávce liší.')],
						[_('Za jak dlouho obdržím objednávku?'), _('Vaši objednávku řidič přijme v co nejkratším čase, avšak nejdéle do 15 minut. Následně ji doručí podle aktuálního vytížení a dopravní situace na trase. V náhledu "stav objednávky" můžete sledovat průběžně aktualizovaný čas doručení.')],
						[_('Proč mám platit kartou?'), _('Při platbě kartou je Vaše objednávka vyřízena s maximální prioritou jako jedna z prvních a současně obdržíte do e-mailu slevový voucher na 5 % z ceny nákupu, který příště využijete Vy nebo kdokoliv, komu ho darujete.')],
						[_('Odkud zboží vozíte?'), _('Po celé ČR budujeme síť výdejních skladů ve spolupráci s lokálními řidiči, kteří z těchto skladů vozí Vaše objednávky.')],
						[_('Jak poznám, zda u nás tato služba funguje?'), _('Prvním krokem je vždy zadání doručovací adresy, pokud u Vás už rozvážíme, dostanete se rovnou k výběru zboží. Pokud u Vás zatím nefungujeme, dostanete po zadání adresy informaci, že jste mimo oblast, kde doručujeme.')],
						[_('Je možné si zboží osobně vyzvednout ve skladu?'), _('Osobní vyzvednutí ve skladu zatím neumožňujeme.')],
						[_('Je možné objednávku bezplatně stornovat?'), _('Ano, dokud není objednávka doručována, ale čeká až s ní řidič vyjede, můžete bezplatně objednávku zrušit v náhledu na stav objednávky.')],
						[_('Mohu dostat při větší nebo opakované objednávce slevu?'), _('Ano, pokud Vaši objednávku uhradíte kartou online, vždy Vám zašleme voucher na slevu ve výši 5 % ze zaplacené částky. Těchto 5 % využijete u příštího nákupu jako slevu.')],
					].map(qa => {
						return {
							className: 'faq-entry',
							children: [{
								nodeName: 'h3',
								textContent: qa[0],
							}, {
								nodeName: 'p',
								textContent: qa[1],
							}]
						};
					})],
				}],
			}, {
				nodeName: 'div',
				className: 'footer',
				children: [{
					className: 'wrap',
					children: [{
						nodeName: 'section',
						className: 'about-us',
						children: [{
							nodeName: 'h2',
							textContent: _('O nás'),
						}, {
							nodeName: 'p',
							textContent: ABOUT_US_TEXT,
						}]
					}, {
						nodeName: 'section',
						className: 'downloads',
						children: [{
							nodeName: 'h2',
							textContent: _('Ke stažení'),
						}, {
							nodeName: 'ul',
							children: ESHOP_DOCUMENTS.map(doc => {
								return {
									nodeName: 'li',
									children: [{
										nodeName: 'a',
										textContent: doc.title,
										target: '_blank',
										href: doc.url,
									}],
								};
							})
						}]
					}, {
						id: 'contact',
						nodeName: 'section',
						className: 'contact',
						children: [{
							nodeName: 'h2',
							textContent: _('Kontakty'),
						}, {
							nodeName: 'p',
							className: 'social',
							children: [{
								nodeName: 'a',
								target: '_blank',
								href: 'https://www.instagram.com/alkoholtaxicz/',
								title: _('Instagram'),
								children: [Utils.useIcon('instagram')],
							}, {
								nodeName: 'a',
								target: '_blank',
								href: 'https://www.facebook.com/alkoholtaxicz',
								title: _('Facebook'),
								children: [Utils.useIcon('facebook')],
							}],
						}, {
							xtype: 'CompanyContacts',
						}]
					}],
				}],
			}, {
				xtype: 'DesignedByBronet',
			}],
		}, this);

		if (!Application.isMobileUI()) {
			let resTimer;
			this.monDom(window, 'resize', ev => {
				clearTimeout(resTimer);
				resTimer = setTimeout(() => {
					this.cacheMenuLocations();
				}, 200);
			});

			this.monDom(window, 'scroll', ev => {
				this.updateMenuSelection();
			});
		}
	},

	updateMenuSelection() {
		let scr = document.scrollingElement;
		let items = this.menuLocationsCache;

		let hl = items[0].el;
		for (let i of items) {
			if (scr.scrollTop > i.top - 80) {
				hl = i.el;
			}
		}

		if (scr.scrollTop > scr.scrollHeight - scr.clientHeight - 200) {
			hl = items[items.length - 1].el;
		}

		for (let i of items) {
			i.el.classList.toggle('selected', i.el === hl);
		}
	},

	cacheMenuLocations() {
		this.menuLocationsCache = Array.from(this.el.querySelectorAll('nav a[href^="#"]')).map(el => {
			let tgt = this.el.querySelector(el.hash);
			if (!tgt) {
				return;
			}

			return {
				el,
				id: el.hash.substring(1),
				top: tgt.getBoundingClientRect().top + document.scrollingElement.scrollTop,
			};
		}).filter(v => v);

		this.updateMenuSelection();
	},

	confirmOver18() {
		return new Promise(res => {
			new Eshop.ModalConfirmDialog({
				closeable: false,
				promptText: _('Bylo Vám 18 let?'),
				onConfirm() {
					localStorage.setItem('over18', '1');
					res(true);
				},
				onCancel() {
					localStorage.setItem('over18', '0');
					location.href = 'https://www.pijsrozumem.cz';
				},
			});
		});
	},

	async selectWarehouse(customerAddress) {
		let latlon = customerAddress.location.split(' ');
		let data = await REST.GET('/api/warehouses', {
			lat: latlon[0],
			lon: latlon[1],
		});

		if (data.active.length == 0 && data.inactive.length == 0) {
			// no warehouses in the area
			Application.showMessage({
				paragraphs: [
					_('Bohužel, ve Vaší lokalitě není tato služba dostupná.'),
					_('Neustále ale pracujeme na jejím rozšíření a věříme, že to brzy změníme.'),
				],
				confirmText: _('Rozumím'),
				onConfirm() {
					this.close();
				},
			});
		} else if (data.active.length == 0) {
			// no active warehouses
			Application.showMessage({
				paragraphs: [
					_('Ve Vaší lokalitě již rozvážíme, ale momentálně není ke skladu přihlášen žádný řidič, zkuste to prosím později.'),
				],
				confirmText: _('Rozumím'),
				onConfirm() {
					this.close();
				},
			});
		} else if (data.inactive.length > 0 && data.inactive[0].distance < data.active[0].distance) {
			Application.showMessage({
				paragraphs: [
					_('Váš nejbližší sklad v tuto chvíli nerozváží. Je ale k dispozici další sklad {warehouse} ve vzdálenosti {distance}.')
						.replace('{warehouse}', data.active[0].name)
						.replace('{distance}', Formats.distance(data.active[0].distance / 1000)),
					_('Chcete přejít do nabídky zboží?.'),
				],
				confirmText: _('Zobrazit produkty'),
				cancelText: _('Zkusím to jindy'),
				onConfirm() {
					Eshop.DataStore.setCustomerAddress(customerAddress);
					Eshop.DataStore.setWarehouse(data.active[0]);
					this.close();
					Application.replaceRoute('/');
				},
			});
		} else {
			Eshop.DataStore.setCustomerAddress(customerAddress);
			Eshop.DataStore.setWarehouse(data.active[0]);
			Application.replaceRoute('/');
		}
	},

	async activate() {
		if (localStorage.getItem('over18') != '1') {
			await this.confirmOver18();
		}

		if (!Application.isMobileUI()) {
			this.cacheMenuLocations();
		}
	},

	deactivate() {
	},
});

// }}}

// Home screen/product selection:

// {{{ Eshop.ShopInfoScreen

GW.define('Eshop.ShopInfoScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				className: 'header',
				children: [{
					xtype: 'AppLogo',
				}, {
					nodeName: 'button',
					className: 'close',
					children: [Utils.useIcon('close')],
					'on:click': ev => {
						PopupManager.hide(this);
					},
				}],
			}, {
				nodeName: 'h2',
				textContent: _('O nás'),
			}, {
				nodeName: 'p',
				textContent: ABOUT_US_TEXT,
			}, {
				nodeName: 'h2',
				textContent: _('Dokumenty'),
			}, ...ESHOP_DOCUMENTS.map(d => {
				return {
					nodeName: 'p',
					children: [{
						nodeName: 'a',
						textContent: d.title + ' (PDF)',
						target: '_blank',
						href: d.url,
					}]
				};
			}), {
				nodeName: 'h2',
				textContent: _('Kontakty'),
			}, {
				xtype: 'CompanyContacts',
			}, {
				xtype: 'DesignedByBronet',
			}],
		}, this);
	},
});

// }}}
// {{{ Eshop.HomeScreen

GW.define('Eshop.HomeScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				ref: 'headerEl',
				className: 'header',
				children: [{
					className: 'topbar',
					children: [{
						xtype: 'AppLogo',
						variant: 'white',
					}, {
						ref: 'cartBtn',
						xtype: 'Eshop.CartButton',
						'on:click': ev => {
							Application.pushRoute('/cart');
						},
					}, {
						nodeName: 'button',
						className: 'transparent icon-center',
						children: [Utils.useIcon('menu')],
						'on:click': ev => Application.showHamburgerMenuContent(ev),
					}],
				}, {
					className: 'address-selector',
					children: [{
						nodeName: 'span',
						className: 'address',
						ref: 'addressEl',
					}, {
						nodeName: 'button',
						className: 'transparent icon-center',
						children: [Utils.useIcon('cross')],
						'on:click': ev => {
							Eshop.DataStore.setWarehouse();
							Eshop.DataStore.closeOrder();
							Application.pushRoute('/');
						},
					}],
				}, {
					className: 'comfort-note',
					children: [Utils.useIcon('car'), {
						className: 'note',
						textContent: _('Ihned po objednání naložíme zboží a vyrážíme k Vám!'),
					}],
				}, {
					className: 'search-ct',
					children: [{
						ref: 'searchEl',
						className: 'search',
						nodeName: 'input',
						type: 'search',
						placeholder: _('Hledat'),
						'on:input': ev => {
							this.searchClearEl.gwHide(!ev.target.value.trim());
							this.doSearch();
						},
					}, {
						ref: 'searchClearEl',
						className: 'clear hidden',
						children: [Utils.useIcon('cross')],
						'on:click': ev => {
							this.searchEl.value = '';
							this.searchClearEl.gwHide(true);
							this.doSearch();
						},
					}]
				}, {
					className: 'category-list',
					children: [{
						ref: 'categoriesEl',
						className: 'category-list-content',
					}],
					'on*:click': ev => {
						let cat = ev.target.closest('.category');
						if (cat) {
							this.shouldScrollToProducts = true;
							Application.pushRoute('/category/' + cat.$cat.id);
						}
					},
				}],
			}, {
				ref: 'bodyEl',
				className: 'product-list',
				children: [{
					ref: 'listHdrEl',
					className: 'list-header',
					children: [{
						ref: 'productsListTitleEl',
						className: 'title',
					}, {
						className: 'scroll-up',
						children: [Utils.useIcon('arrow-up')],
					}],
					'on:click': ev => {
						scrollTo({
							top: 0,
							left: 0,
							behavior: 'smooth'
						});
					},
				}, {
					ref: 'productsEl',
					className: 'product-grid',
				}]
			}, {
				ref: 'footerEl',
				className: 'footer',
			}],
		}, this);

		this.products = [];

		this.monDom(window, 'scroll', ev => {
			let el = ev.target.documentElement;

			this.listHdrEl.classList.toggle('stuck', el.scrollTop > this.headerEl.offsetHeight);

			if (el.scrollTop + el.clientHeight > el.scrollHeight - 2000) {
				this.limit += 50;
				this.renderProducts();
			}
		});
	},

	doSearch() {
		let query = this.searchEl.value.trim();
		this.categoriesEl.classList.toggle('hidden', !!query);
		if (!query) {
			this.limit = 30;
			this.onDataChange(Eshop.DataStore.changesAll);
			return;
		}

		this.productsListTitleEl.textContent = _('Výsledky hledání');

		let matcher = TextUtils.createMatchAll(query);

		this.limit = 30;
		this.products = Eshop.DataStore.getProducts().filter(p => {
			return matcher(p.name);
		});

		this.renderProducts();
		this.footerEl.textContent = '';
	},

	getSelectedCategory() {
		let cat = this.categoriesEl.querySelector('.category.selected');

		return cat && cat.$cat;
	},

	setSelectedCategory(id) {
		Utils.selectListItem(this.categoriesEl, '.category', 'selected', i => i.$cat.id == id);
	},

	renderCategories(categories) {
		Utils.syncRenderList({
			ct: this.categoriesEl,
			id: i => i.id,
			eq: (a, b) => a.version === b.version,
			list: categories,
			keepSelection: false,
			onAdd(c) {
				let photoPath = '/imgs/cat-noimg.svg';
				if (c.photo) {
					photoPath = '/api/files/' + c.photo;
				} else if (c.photoPath) {
					photoPath = c.photoPath;
				}

				return document.gwCreateElement({
					$cat: c,
					className: 'category',
					children: [{
						nodeName: 'img',
						loading: 'lazy',
						src: photoPath,
					}, {
						className: 'caption',
						textContent: c.name,
					}],
				});
			},
		});
	},

	showProductDetail(p, ev) {
		if (Eshop.DataStore.getProductStock(p.id) <= 0) {
			return;
		}

		let detail = new Eshop.ProductDetail({
			product: p,
		});

		detail.load();

		PopupManager.show(detail, {
			anchorEvent: ev,
		});
	},

	renderProducts() {
		this.productsEl.className = 'product-grid';

		Utils.syncRenderList({
			ct: this.productsEl,
			id: i => i.id,
			eq: (a, b) => a.version === b.version,
			list: this.products.slice(0, this.limit),
			keepSelection: false,
			onAdd: p => {
				return document.gwCreateElement({
					$prod: p,
					className: 'product',
					children: [{
						ref: '$note',
						className: 'min-price-note hidden',
					}, {
						className: 'photo',
						children: [{
							nodeName: 'img',
							loading: 'lazy',
							width: p.photo_size ? p.photo_size[0] : 55,
							height: p.photo_size ? p.photo_size[1] : 160,
							src: p.photo ? '/api/files/' + p.photo : '/imgs/prod-noimg.svg',
						}],
						'on:click': ev => this.showProductDetail(p, ev),
					}, {
						className: 'caption',
						textContent: p.name,
						'on:click': ev => this.showProductDetail(p, ev),
					}, {
						className: 'info',
						children: [{
							className: 'amount',
							textContent: p.amount,
						}, {
							className: 'price',
							textContent: Formats.price(p.price),
						}]
					}, {
						ref: '$qtyChooser',
						xtype: 'Eshop.CartQtyChooser',
						product: p,
					}],
				});
			},
		});

		this.bodyEl.querySelectorAll('.products-empty').forEach(el => el.remove());
		if (this.products.length == 0) {
			this.bodyEl.gwCreateChild({
				className: 'products-empty',
				textContent: this.searchEl.value.trim() ?
					_('Nebylo nalezeno žádné odpovídající zboží') :
					_('V této kategorii není dostupné žádné zboží'),
			});
		}

		for (let el of this.bodyEl.querySelectorAll('.product')) {
			let stock = Eshop.DataStore.getProductStock(el.$prod.id);

			el.$qtyChooser.setMax(stock);
			el.classList.toggle('out-of-stock', stock == 0);
		}

		this.updateLimits();
	},

	scrollToProducts() {
		scrollTo({
			top: this.bodyEl.getBoundingClientRect().top + document.scrollingElement.scrollTop - 180,
			left: 0,
			behavior: 'smooth',
		});
	},

	updateLimits() {
		let cart = Eshop.DataStore.getCartOverview();

		for (let el of this.bodyEl.querySelectorAll('.product')) {
			let product = el.$prod;
			let note;

			if (product.min_order_price && product.min_order_price > cart.unconditional_total) {
				note = _('Nejprve kupte jiné zboží ještě za {price}')
					.replace('{price}', Formats.price(product.min_order_price - cart.unconditional_total));
			}

			el.$note.textContent = note;
			el.$note.classList.toggle('hidden', !note);

			el.$qtyChooser.setDisabled(!!note);
		}
	},

	onDataChange(changes) {
		if (changes.anyOf('customer-address')) {
			this.addressEl.textContent = Formats.address(Eshop.DataStore.getCustomerAddress());
		}

		if (changes.anyOf('cart')) {
			this.cartBtn.setValue(Eshop.DataStore.getCartSize());
		}

		if (!Eshop.DataStore.isSynced()) {
			return;
		}

		if (changes.anyOf('products', 'synced')) {
			let cats = Eshop.DataStore.getCategories();
			let products = Eshop.DataStore.getProducts();

			this.renderCategories(cats);
			this.categoriesEl.classList.remove('hidden');

			// select category
			this.setSelectedCategory(this.category);

			let cat = this.getSelectedCategory();
			if (cat) {
				this.productsListTitleEl.textContent = cat.name;
			} else {
				this.productsListTitleEl.textContent = '...';
			}

			if (this.searchEl.value.trim()) {
				this.doSearch();
				return;
			}

			if (this.category == 'all') {
				this.products = products;
			} else if (this.category == 'fav') {
				this.products = products.filter(p => p.favorited);

				if (this.products.length == 0) {
					Application.replaceRoute('/category/all');
					return;
				}
			} else {
				this.products = products.filter(p => p.category == this.category);
			}

			this.renderProducts();

			if (this.shouldScrollToProducts) {
				this.scrollToProducts();
				this.shouldScrollToProducts = false;
			}
		}

		if (changes.anyOf('cart', 'products', 'synced')) {
			this.updateLimits();
		}
	},

	async loadCategory(id) {
		this.footerEl.textContent = '';
		this.searchEl.value = '';
		this.searchClearEl.gwHide(true);
		this.category = id;

                this.limit = 30;

		this.onDataChange(Eshop.DataStore.changesAll);
	},
});

// }}}
// {{{ Eshop.ProductDetail

GW.define('Eshop.ProductDetail', 'GW.Component', {
	product: null,

	initComponent() {
		let p = this.product;

		this.el = document.gwCreateElement({
			children: [{
				className: 'header',
				children: [{
					ref: 'cartInfoTextEl',
					className: 'cart-info-note hidden',
				}, {
					nodeName: 'button',
					children: [Utils.useIcon('close')],
					'on:click': ev => {
						PopupManager.hide(this);
					},
				}],
			}, {
				className: 'overview',
				children: [{
					ref: 'photoEl',
					className: 'photo',
					nodeName: 'img',
					loading: 'lazy',
					width: p.photo_size ? p.photo_size[0] : undefined,
					height: p.photo_size ? p.photo_size[1] : undefined,
					src: p.photo ? '/api/files/' + p.photo : '/imgs/prod-noimg.svg',
				}, {
					className: 'info',
					children: [{
						className: 'title',
						textContent: p.name,
					}, {
						className: 'price-amount',
						children: [{
							className: 'amount',
							nodeName: 'span',
							textContent: p.amount,
						}, {
							className: 'price',
							nodeName: 'span',
							textContent: Formats.price(p.price),
						}],
					}, {
						className: 'stock',
						ref: 'stockInfo',
					}, {
						ref: 'qtyChooser',
						xtype: 'Eshop.CartQtyChooser',
						product: p,
					}, {
						ref: '$errMsg',
						className: 'qty-error hidden',
					}],
				}],
			}, {
				ref: 'cartLimitInfoTextEl',
				className: 'order-limit-info-note hidden',
			}, {
				ref: 'descEl',
				className: 'description',
			}],
		}, this);

		this.refresh();
	},

	refresh() {
		let p = this.product;
		let qty = Eshop.DataStore.getCartItemQty(p.id);
		let stock = Eshop.DataStore.getProductStock(p.id);
		let cart = Eshop.DataStore.getCartOverview();

		let note;
		if (p.min_order_price && p.min_order_price > cart.unconditional_total) {
			note = _('Nejprve kupte jiné zboží ještě za {price}')
				.replace('{price}', Formats.price(p.min_order_price - cart.unconditional_total));
		}

		this.cartLimitInfoTextEl.textContent = note;
		this.cartLimitInfoTextEl.classList.toggle('hidden', !note);

		this.cartInfoTextEl.textContent = _n(qty, 'V košíku máte {n} kus');
		this.cartInfoTextEl.classList.toggle('hidden', qty == 0);

		this.qtyChooser.setDisabled(!!note);
		this.qtyChooser.setMax(stock);

		this.stockInfo.gwReplaceChildren([
			Utils.useIcon('check'), {
				nodeName: 'span',
				textContent: _n(stock, 'Skladem {n} kus'),
			}
		]);
	},

	onDataChange(changes) {
		if (changes.anyOf('products', 'cart')) {
			this.refresh();
		}
	},

	async load() {
		try {
			this.descEl.gwReplaceChildren([{
				className: 'load-progress',
				textContent: '...',
			}]);

			let p = await REST.GET('/api/products/' + this.product.id);

			this.descEl.textContent = p.description;
		} catch (ex) {
			this.descEl.gwReplaceChildren([{
				className: 'load-failed',
				textContent: _('Načtení popisu selhalo'),
			}]);
		}
	},
});

// }}}

// Checkout process:

// {{{ Eshop.CheckoutProgress

GW.define('Eshop.CheckoutProgress', 'GW.Component', {
	value: 1,
	steps: [],

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'checkout-progress',
			'on*:click': ev => {
				let el = ev.target.closest('.step:not(.inactive)');
				if (el) {
					this.fire('beforechange', el.$step.value)
				}
			},
		});

		this.refresh();
	},

	refresh() {
		let steps = this.steps.filter(s => !s.hidden);
		let els = steps.map((s, idx) => {
			return [{
				$step: s,
				className: 'step' + (s.value == this.value ? ' selected' : '') + (s.inactive ? ' inactive' : ''),
				title: s.name,
				children: [{
					className: 'step-idx',
					textContent: s.value,
				}, {
					className: 'step-name',
					textContent: s.name,
				}]
			}, {
				':skip': idx == steps.length - 1,
				className: 'dash',
			}];
		}).flat();

		this.el.gwReplaceChildren(els);
	},

	setSteps(steps) {
		this.steps = steps;

		this.refresh();
	},

	setValue(v) {
		this.value = v;
		Utils.selectListItem(this.el, '.step', 'selected', i => i.$step.value === v);
	},

	getValue() {
		let el = this.el.querySelector('.step.selected');

		return el && el.$step.value;
	},
});

// }}}
// {{{ Eshop.CheckoutScreen

GW.define('Eshop.CheckoutScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'checkout-screen',
			children: [{
				className: 'topbar',
				children: [{
					xtype: 'AppLogo',
				}, {
					nodeName: 'button',
					className: 'transparent icon-center',
					children: [Utils.useIcon('menu')],
					'on:click': ev => Application.showHamburgerMenuContent(ev),
				}],
			}, {
				ref: 'progress',
				xtype: 'Eshop.CheckoutProgress',
				'on:beforechange': (c, step) => {
					if (step == 1) {
						Application.pushRoute('/cart');
					} else if (step < 4) {
						if (!Eshop.DataStore.canAccess('checkout' + step)) {
							return;
						}

						Application.pushRoute('/checkout/' + step);
					}
				},
			}, {
				ref: 'bodyEl',
			}, {
				ref: 'footerEl',
				className: 'footer',
			}],
		}, this);

		this.updateProgressSteps();
	},

	updateProgressSteps(forceFinalPayment) {
		this.progress.setSteps([{
			value: 1,
			name: _('Váš nákup'),
			inactive: forceFinalPayment,
		}, {
			value: 2,
			name: _('Platba'),
			inactive: !Eshop.DataStore.canAccess('checkout2') || forceFinalPayment,
		}, {
			value: 3,
			name: _('Vaše údaje'),
			inactive: !Eshop.DataStore.canAccess('checkout3') || forceFinalPayment,
		}, {
			value: 4,
			name: _('Souhrn'),
			inactive: !Eshop.DataStore.canAccess('checkout4') || forceFinalPayment,
		}, {
			inactive: true,
			hidden: forceFinalPayment ? false : (Eshop.DataStore.getPaymentMethod() || 'card') != 'card',
			value: 5,
			name: _('Zaplatit'),
		}]);
	},

	renderButtons(backUrl, nextText, nextCb) {
		this.footerEl.textContent = '';
		this.footerEl.gwCreateChild({
			className: 'buttons',
			children: [{
				nodeName: 'button',
				className: 'tertiary icon-left',
				children: [Utils.useIcon('arrow-left'), {
					className: 'text',
					textContent: _('Zpět'),
				}],
				'on:click': ev => {
					Application.pushRoute(backUrl);
				},
			}, {
				nodeName: 'button',
				className: 'primary icon-right',
				children: [{
					className: 'text',
					textContent: nextText,
				}, Utils.useIcon('arrow-right')],
				'on:click': ev => {
					nextCb();
				},
			}]
		});
	},

	renderProduct(item, modifiable) {
		return document.gwCreateElement({
			$prod: item,
			className: 'product' + (modifiable ? '' : ' non-modifiable') + (item.issues.length == 0 ? '' : ' has-issues'),
			children: [{
				nodeName: 'img',
				loading: 'lazy',
				src: item.product.photo ? '/api/files/' + item.product.photo : '/imgs/prod-noimg.svg',
			}, {
				className: 'info',
				children: [{
					className: 'name',
					nodeName: 'span',
					textContent: item.product.name,
				}, ', ', {
					className: 'amount',
					nodeName: 'span',
					textContent: item.product.amount,
				}],
			}, {
				':skip': modifiable,
				className: 'qty',
				textContent: item.qty + 'x',
			}, {
				':skip': !modifiable,
				xtype: 'Eshop.CartQtyChooser',
				product: item.product,
			}, {
				className: 'price',
				textContent: Formats.price(item.product.price * item.qty),
			}, {
				':skip': !modifiable,
				className: 'remove',
				children: [Utils.useIcon('cross')],
				'on:click': ev => {
					Eshop.DataStore.setCartItemCheckDeps(item.product, 0);
				},
			}, {
				ref: '$errMsg',
				className: 'error' + (item.issues.length == 0 ? ' hidden' : ''),
				children: item.issues.map(i => {
					return {
						className: 'issue',
						textContent: i,
					};
				}).concat([{
					className: 'resolve-buttons',
					children: [{
						nodeName: 'button',
						className: 'primary',
						textContent: _('Vyřešit problém'),
						'on:click': ev => {
							ev.preventDefault();
							Eshop.DataStore.resolveCartProductIssues(item.product);
						},
					}]
				}])
			}],
		});
	},

	renderCart(ct, cart, modifiable) {
		if (!ct.$itemsEl || !ct.$totalsEl) {
			ct.gwReplaceChildren([{
				ref: '$itemsEl',
				className: 'products-table',
			}, {
				ref: '$totalsEl',
				className: 'totals-table',
			}], ct);
		}

		Utils.syncRenderList({
			ct: ct.$itemsEl,
			id: i => i.product.id,
			list: cart.items.map(i => {
				return {
					...i,
					issues: Eshop.DataStore.getProductIssues(i.product),
				};
			}),
			keepSelection: false,
			onAdd: p => {
				return this.renderProduct(p, modifiable);
			},
		});

		if (cart.items.length == 0) {
			ct.$itemsEl.gwCreateChild({
				className: 'note',
				textContent: _('Váš košík je prázdný'),
			});
		}

		function row(label, value, cls) {
			return {
				className: 'row' + (cls ? ' ' + cls : ''),
				children: [{
					className: 'label',
					textContent: label,
				}, {
					className: 'value',
					textContent: value,
				}]
			};
		}

		ct.$totalsEl.gwReplaceChildren([
			row(_('Doprava'), cart.shipping_cost == null ? _('určuje se') : Formats.price(cart.shipping_cost)),
			cart.discount > 0 ? row(_('Slevový kupón') + ' "' + cart.coupon_code + '"', Formats.price(-cart.discount)) : null,
			row(_('Celkem s DPH'), Formats.price(cart.total), 'total'),
			//row('', Formats.price(total_without_dph) + ' ' + _('bez DPH'), 'without-vat'),
			row('', _('Nejsme plátci DPH'), 'without-vat'),
		]);
	},
});

// }}}
// {{{ Eshop.CheckoutScreen1 - cart

GW.define('Eshop.CheckoutScreen1', 'Eshop.CheckoutScreen', {
	'after:initComponent'() {
		this.bodyEl.className = 'step1';
		this.progress.setValue(1);
	},

	renderEmptyCart() {
		this.progress.el.gwHide(true);
		this.footerEl.textContent = '';
		this.bodyEl.classList.add('empty-cart');

		this.bodyEl.gwReplaceChildren([{
			className: 'empty-icon',
			children: [Utils.useIcon('bigcart')],
		}, {
			nodeName: 'h2',
			textContent: _('V košíku nic není'),
		}, {
			nodeName: 'button',
			className: 'primary',
			textContent: _('Chci to napravit'),
			'on:click': ev => {
				ev.preventDefault();
				Application.pushRoute('/');
			},
		}]);

		delete this.cartContentEl;
	},

	renderFullCart() {
		this.bodyEl.classList.remove('empty-cart');
		this.progress.el.gwHide(false);
		this.renderButtons('/', _('Pokračovat'), () => {
			Application.pushRoute('/checkout/2');
		});

		let cart = Eshop.DataStore.getCartOverview();

		if (!this.cartContentEl) {
			this.bodyEl.gwReplaceChildren([{
				className: 'cart-content',
				ref: 'cartContentEl',
			}, {
				className: 'coupon-ct',
				ref: 'couponCt',
				children: [{
					xtype: 'TextField',
					name: 'coupon_code',
					label: _('Máte-li slevový kupón, můžete jeho kód zadat do následujícího políčka'),
					placeholder: _('např. fbqwer81sdf'),
					'on:change': c => {
						c.sendBtn.disabled = !c.getValue();
					},
					'after:initComponent'() {
						this.sendBtn = this.inputCt.gwCreateChild({
							nodeName: 'button',
							textContent: _('Aplikovat'),
							disabled: true,
							className: 'secondary',
							'on:click': async ev => {
								this.sendBtn.disabled = true;
								
								try {
									let code = this.getValue().toLowerCase();
									if (!code.match(/^([a-z0-9]+)$/)) {
										throw new Error(_('Kód kupónu je chybný'));
									}

									let coupon = await REST.GET('/api/coupons/' + encodeURIComponent(code));
									if (coupon.used_up) {
										throw new Error(_('Kupón již je vyčerpaný'));
									} else if (coupon.expired) {
										throw new Error(_('Kupón vypršel'));
									}

									Eshop.DataStore.applyDiscountCoupon(code, coupon.amount, coupon.amount_kind);
								} catch(ex) {
									this.sendBtn.disabled = false;
									this.setValue();
									throw ex;
								}

								this.setValue();
							},
						});
					},
				}]
			}], this);
		}

		this.couponCt.gwHide(cart.discount > 0);

		this.renderCart(this.cartContentEl, cart, true);
	},

	onDataChange(changes) {
		let isEmpty = Eshop.DataStore.getCartSize() == 0;
		if (!Eshop.DataStore.isSynced()) {
			return;
		}

		if (!isEmpty && changes.anyOf('products', 'cart', 'synced')) {
			this.renderFullCart();
		}

		if (isEmpty && changes.anyOf('cart', 'synced')) {
			this.renderEmptyCart();
		}
	},
});

// }}}
// {{{ Eshop.CheckoutScreen2 - payment method

GW.define('Eshop.CheckoutScreen2', 'Eshop.CheckoutScreen', {
	'after:initComponent'() {
		this.bodyEl.className = 'step2';
		this.progress.setValue(2);

		this.bodyEl.addEventListener('click', ev => {
			let b = ev.target.closest('button');
			if (b && b.$method) {
				Eshop.DataStore.setPaymentMethod(b.$method.id);
			}
		}, true);

		this.renderButtons('/cart', _('Pokračovat'), () => {
			Application.pushRoute('/checkout/3');
		});

		this.footerEl.gwCreateChild({
			className: 'logos',
			children: 'csob.png maestro.png mc.png visa-el.png visa.png ver-mc.png ver-visa.png'.split(' ').map(name => {
				return {
					nodeName: 'img',
					src: '/imgs/logos/' + name,
				};
			})
		});

		this.renderPaymentMethods();
	},

	renderPaymentMethods() {
		let nextBtn = this.footerEl.querySelector('button.primary');
		let cart = Eshop.DataStore.getCartOverview();
		let methods = Eshop.DataStore.getAvailablePaymentMethods(cart);

		// determine what payment method to pre-select
		// - if none was chosen yet, prefer card or the one that was
		//   selected
		// - if that is not available, prefer the first available one
		let selected_method = Eshop.DataStore.getPaymentMethod() || 'card';
		if (!methods.some(m => m.id == selected_method && m.errors.length == 0)) {
			let method = methods.find(m => m.errors.length == 0);

			selected_method = method ? method.id : null;
		}

		this.bodyEl.textContent = '';

		// special case for an order fully paid by a voucher
		// to skip payment selection screen
		if (cart.total == 0) {
			this.bodyEl.gwCreateChild({
				nodeName: 'p',
				textContent: _('Vaše objednávka bude plně zaplacena ze slevového kupónu.'),
			});

			Eshop.DataStore.setPaymentMethod('cash');
			nextBtn.disabled = false;
			return;
		}

		// show payment method buttons
		for (let m of methods) {
			let available = (m.errors || []).length == 0;

			this.bodyEl.gwCreateChild({
				$method: m,
				nodeName: 'button',
				className: (selected_method == m.id && available ? 'secondary' : 'tertiary') + ' icon-left icon-right',
				'attr:data-method': m.id,
				disabled: !available,
				children: [Utils.useIcon(m.icon), {
					className: 'text',
					textContent: m.text,
				}, Utils.useIcon('check')],
			});
		}

		// show error messages for a selected payment method
		for (let m of methods) {
			for (let msg of m.errors || []) {
				this.bodyEl.gwCreateChild({
					nodeName: 'p',
					className: 'limit',
					textContent: msg,
				});
			}
		}

		// show generic info messages for all payment methods at the end
		for (let m of methods) {
			for (let msg of m.messages || []) {
				this.bodyEl.gwCreateChild({
					nodeName: 'p',
					textContent: msg,
				});
			}
		}

		Eshop.DataStore.setPaymentMethod(selected_method);
		nextBtn.disabled = !selected_method;

		this.updateProgressSteps();
	},

	getPaymentMethod() {
		let sel = this.bodyEl.querySelector('button.secondary');

		return sel ? sel.$method : null;
	},

	onDataChange(changes) {
		if (changes.anyOf('products', 'cart', 'synced')) {
			if (Eshop.DataStore.isSynced()) {
				this.renderPaymentMethods();
			}
		}
	},
});

// }}}
// {{{ Eshop.CheckoutScreen3 - customer info

GW.define('Eshop.CheckoutScreen3', 'Eshop.CheckoutScreen', {
	'after:initComponent'() {
		this.bodyEl.className = 'step3';
		this.progress.setValue(3);

		this.bodyEl.gwReplaceChildren([{
			nodeName: 'form',
			noValidate: true,
			'on:submit': ev => {
				ev.preventDefault();
				this.saveStep3();
			},
			className: 'form',
			children: [{
				xtype: 'TextField',
				name: 'name',
				label: _('Jméno a příjmení'),
			}, {
				xtype: 'TextField',
				name: 'email',
				type: 'email',
				label: _('E-Mail'),
			}, {
				xtype: 'TextField',
				name: 'phone',
				type: 'tel',
				label: _('Telefon'),
			}, {
				nodeName: 'h2',
				textContent: _('Dodací adresa'),
			}, {
				nodeName: 'p',
				textContent: Formats.address(Eshop.DataStore.getCustomerAddress()),
			}, {
				nodeName: 'h2',
				textContent: _('Fakturační adresa'),
			}, {
				optional: true,
				xtype: 'AckCheckboxField',
				name: 'no_billing_address',
				shortText: _('Stejná jako dodací adresa'),
				value: true,
				'on:change': c => this.refresh(),
			}, {
				group: 'billing',
				xtype: 'TextField',
				name: 'billing_street',
				label: _('Ulice a číslo popisné'),
			}, {
				group: 'billing',
				xtype: 'TextField',
				name: 'billing_city',
				label: _('Město'),
			}, {
				group: 'billing',
				xtype: 'TextField',
				name: 'billing_post_code',
				label: _('PSČ'),
			}, {
				optional: true,
				xtype: 'AckCheckboxField',
				name: 'has_company_info',
				shortText: _('Chci zadat firemní údaje'),
				'on:change': c => this.refresh(),
			}, {
				group: 'company',
				xtype: 'TextField',
				name: 'company_name',
				label: _('Název firmy'),
			}, {
				className: 'columns',
				children: [{
					group: 'company',
					xtype: 'TextField',
					name: 'company_ic',
					label: _('IČ'),
				}, {
					group: 'company',
					xtype: 'TextField',
					name: 'company_dic',
					label: _('DIČ'),
					optional: true,
				}],
			}, {
				optional: true,
				xtype: 'TextareaField',
				name: 'note',
				label: _('Poznámka k objednávce'),
			}],
		}])

		this.renderButtons('/checkout/2', _('Pokračovat'), () => {
			this.save();
		});

		this.on('change', c => this.onChange(c), this, true);
	},

	refresh() {
		let cb = this.getChild(c => c.name == 'no_billing_address');
		let cc = this.getChild(c => c.name == 'has_company_info');

		this.getChildren(c => c.group == 'billing').forEach(c => {
			c.el.classList.toggle('hidden', cb.getValue());
			c.setDisabled(cb.getValue());
		});

		this.getChildren(c => c.group == 'company').forEach(c => {
			c.el.classList.toggle('hidden', !cc.getValue());
			c.setDisabled(!cc.getValue());
		});
	},

	activate() {
		let data = Eshop.DataStore.getOrderInfo();
		if (data) {
			this.setFormFieldsData(data);
		}

		this.refresh();
	},

	onChange(c) {
		let data = this.getFormFieldsData();

		Eshop.DataStore.setOrderInfo(data);
	},

	save() {
		if (!this.reportFormValid()) {
			return;
		}

		// save one last time
		this.onChange();

		Eshop.DataStore.refreshStockProducts();

		Application.show({
			id: 'eshop.checkout4',
			xtype: 'Eshop.CheckoutScreen4',
		});
	},

	...FormMixin,
});

// }}}
// {{{ Eshop.CheckoutScreen4 - overview

GW.define('Eshop.CheckoutScreen4', 'Eshop.CheckoutScreen', {
	'after:initComponent'() {
		this.bodyEl.className = 'step4';
		this.progress.setValue(4);

		this.bodyEl.gwReplaceChildren([{
			className: 'overview',
			ref: 'overviewCt',
			children: [{
				nodeName: 'h2',
				textContent: _('Váš nákup'),
			}, {
				ref: 'cartContentEl',
				className: 'cart-content',
			}, {
				nodeName: 'h2',
				textContent: _('Platba'),
			}, {
				ref: 'paymentMethodEl',
				className: 'payment-type',
			}, {
				nodeName: 'h2',
				textContent: _('Vaše údaje'),
			}, {
				ref: 'customerInfoEl',
				className: 'customer-info',
			}]
		}, {
			className: 'agreements',
			ref: 'agreementsCt',
			children: [{
				nodeName: 'h2',
				textContent: _('Souhlasy a dokončení objednávky'),
			}, {
				nodeName: 'form',
				noValidate: true,
				'on:submit': ev => {
					ev.preventDefault();
				},
				className: 'form',
				children: [{
					xtype: 'AckCheckboxField',
					name: 'agree_tos',
					shortText: _('Četl jsem obchodní podmínky a přistupuji k nim'),
					getLinks() {
						return [{
							nodeName: 'a',
							href: '/docs/Obchodní podmínky pro nákup na alkoholtaxi.cz.pdf',
							target: '_blank',
							textContent: _('Obchodní podmínky (PDF)'),
						}];
					},
				}, {
					xtype: 'AckCheckboxField',
					name: 'agree_privacy',
					shortText: _('Souhlasím se zpracováním osobních údajů'),
					getLinks() {
						return [{
							nodeName: 'a',
							href: '/docs/Ochrana osobních údajů e-shopu alkoholtaxi.cz - Příloha č. 3 k OP.pdf',
							target: '_blank',
							textContent: _('Pravidla zpracování osobních údajů (PDF)'),
						}];
					},
				}]
			}],
		}, {
			ref: 'noticeEl',
			className: 'warning hidden',
		}], this);

		this.renderButtons('/checkout/3', _('Objednat'), async () => {
			if (!this.orderData) {
				throw new Error(_('Obejdnávku nelze odeslat'));
			}

			let btns = Array.from(this.footerEl.querySelectorAll('button'));

			try {
				btns.forEach(b => b.disabled = true);

				await this.createOrder(this.orderData);
			} catch (ex) {
				if (ex.reason == 'coupon') {
					Eshop.DataStore.clearDiscountCoupon();
					this.noticeEl.gwHide(false);
					this.noticeEl.textContent = _('Slevový kupón byl z objednávky automaticky odstraněn, protože již nelze aplikovat. Překontrolujte si prosím přehled objednávky.') + ' ' + ex.message;
					await Utils.timeoutPromise(2000);
					btns.forEach(b => b.disabled = false);
					return;
				}

				throw ex;
			} finally {
				btns.forEach(b => b.disabled = false);
			}
		});
	},

	renderCustomerInfo(ct, data) {
		function row(label, value, cls) {
			if (!value) {
				return null;
			}

			return {
				className: 'form-field' + (cls ? ' ' + cls : ''),
				children: [{
					nodeName: 'label',
					textContent: label,
				}, {
					className: 'input-ct',
					textContent: value,
				}]
			};
		}

		let shipping_address = Formats.address(Eshop.DataStore.getCustomerAddress());
		let billing_address = !data.no_billing_address ? data.billing_street + ', ' + data.billing_post_code + ' ' + data.billing_city : shipping_address;

		let rows = [
			row(_('Jméno a příjmení'), data.name),
			row(_('Email'), data.email),
			row(_('Telefon'), data.phone),
			row(_('Dodací adresa'), shipping_address),
			row(_('Fakturační adresa'), billing_address),
			data.has_company_info ? {
				className: 'form-field',
				children: [{
					nodeName: 'label',
					textContent: _('Firemní údaje'),
				}, {
					className: 'input-ct',
					children: [{
						textContent: data.company_name,
					}, {
						children: [{
							nodeName: 'span',
							className: 'label',
							textContent: _('IČ') + ': ',
						}, {
							nodeName: 'span',
							textContent: data.company_ic,
						}]
					}, {
						':skip': !data.company_dic,
						children: [{
							nodeName: 'span',
							className: 'label',
							textContent: _('DIČ') + ': ',
						}, {
							nodeName: 'span',
							textContent: data.company_dic,
						}]
					}]
				}]
			} : undefined,
			row(_('Poznámka'), data.note),
		];

		ct.gwReplaceChildren(rows);
	},

	getPaymentMethodText(method, fullCoupon) {
		if (fullCoupon) {
			return _('Slevovým kupónem');
		}

		if (method == 'cash') {
			return _('Hotově při převzetí');
		} else if (method == 'card') {
			return _('Platební kartou online');
		} else {
			return _('Neznámá');
		}
	},

	renderSummary() {
		let customer = Eshop.DataStore.getOrderInfo();
		let cart = Eshop.DataStore.getCartOverview();
		let payment = Eshop.DataStore.getPaymentMethod();

		/* 
		 * Save order data for later, so that we are sure we send to the
		 * server what the user saw in the overview
		 */
		this.orderData = {customer, cart, payment};

		this.paymentMethodEl.textContent = this.getPaymentMethodText(payment, cart.total == 0);
		this.renderCart(this.cartContentEl, cart);
		this.renderCustomerInfo(this.customerInfoEl, customer);
	},

	onDataChange(changes) {
		if (changes.anyOf('products', 'cart', 'synced')) {
			if (Eshop.DataStore.isSynced()) {
				this.renderSummary();
			}
		}
	},

	async createOrder({customer, cart, payment}) {
		if (!this.reportFormValid()) {
			return;
		}

		let sa = Formats.address_parts(Eshop.DataStore.getCustomerAddress());
		let warehouse = Eshop.DataStore.getWarehouse();

		if (!sa || !warehouse) {
			throw new Error(_('Objednávka není kompletní'));
		}

		for (let item of cart.items) {
			let issues = Eshop.DataStore.getProductIssues(item.product);
			if (issues.length > 0) {
				throw new Error(_('Některé Vámi objednávané produkty nejsou již dostupné. Prosíme zkontrolujte přehled objednávky a potvrďte změny.'));
			}
		}

		let data = {
			products: cart.items.map(item => {
				return {
					id: item.product.id,
					version: item.product.version,
					price: item.product.price,
					quantity: item.qty,
				};
			}),

			customer_name: customer.name,
			customer_phone: customer.phone,
			customer_email: customer.email,

			shipping_street: sa.street,
			shipping_city: sa.city,
			shipping_post_code: sa.post_code,
			shipping_location: sa.location,

			warehouse: warehouse.id,

			payment_method: (cart.total == 0) ? 'cash' : payment,
		};

		if (cart.discount > 0) {
			data.coupon_discount = cart.discount;
			data.coupon_code = cart.coupon_code;
		}

		data.billing_address = false;
		if (!customer.no_billing_address) {
			Object.assign(data, {
				billing_address: true,
				billing_street: customer.billing_street,
				billing_city: customer.billing_city,
				billing_post_code: customer.billing_post_code,
			});
		}

		data.company_info = false;
		if (customer.has_company_info) {
			Object.assign(data, {
				company_info: true,
				company_name: customer.company_name,
				company_ic: customer.company_ic,
				company_dic: customer.company_dic,
			});
		}

		data.address = Eshop.DataStore.getCustomerAddress();
		data.shipping_cost = Eshop.DataStore.getShippingCost();
		data.shipping_cost_key = Eshop.DataStore.getShippingCostKey();

		data.customer_note = customer.note;

		let order;
		try {
			order = await REST.POST('/api/orders', data);
		} catch (ex) {
			Eshop.DataStore.refreshStockProducts();
			throw ex;
		}

		Eshop.DataStore.closeOrder();
		Application.pushRoute('/orders/' + order.secret);
	},

	...FormMixin,
});

// }}}
// {{{ Eshop.CheckoutScreen5 - payment button

GW.define('Eshop.CheckoutScreen5', 'Eshop.CheckoutScreen', {
	'after:initComponent'() {
		this.bodyEl.className = 'step5';
		this.progress.setValue(5);
		this.updateProgressSteps(true);

		this.footerEl.gwCreateChild({
			className: 'logos',
			children: 'csob.png maestro.png mc.png visa-el.png visa.png ver-mc.png ver-visa.png'.split(' ').map(name => {
				return {
					nodeName: 'img',
					src: '/imgs/logos/' + name,
				};
			})
		});
	},

	setData(redirect_url) {
		this.bodyEl.gwCreateChild({
			className: 'warning',
			children: [{
				nodeName: 'p',
				textContent: _('Nyní zaplaťte svou objednávku kartou. Po zaplacení začneme Vaší objednávku okamžitě vyřizovat.'),
			}, {
				nodeName: 'p',
				textContent: _('Na zaplacení objednávky máte 15 minut, potom bude automaticky stornována.'),
			}],
		});

		this.bodyEl.gwCreateChild({
			className: 'pay-buttons',
			children: [{
				nodeName: 'button',
				className: 'secondary icon-left pay-button',
				children: [Utils.useIcon('card'), {
					className: 'text',
					textContent: _('Zaplatit online'),
				}],
				'on:click': ev => {
					location.href = redirect_url;
				},
			}],
		});

		this.bodyEl.gwCreateChild({
			className: 'cancel',
			children: [{
				nodeName: 'button',
				className: 'tertiary',
				textContent: _('Zrušit objednávku'),
				'on:click': ev => {
					ev.preventDefault();
					this.cancelOrder();
				},
			}],
		});
	},

	async cancelOrder() {
		if (!confirm(_('Opravdu chcete zrušit objednávku?'))) {
			return;
		}

		await REST.POST('/api/orders/' + this.secret_key + '/cancel');
		location.reload();
	},
});

// }}}

// Order status/payments:

// {{{ Eshop.OrderStatusScreen

GW.define('Eshop.OrderStatusScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'order-screen',
			children: [{
				className: 'topbar',
				children: [{
					xtype: 'AppLogo',
				}, {
					nodeName: 'button',
					className: 'transparent icon-center',
					children: [Utils.useIcon('menu')],
					'on:click': ev => Application.showHamburgerMenuContent(ev),
				}],
			}, {
				ref: 'bodyEl',
				className: 'body',
			}, {
				ref: 'footerEl',
				className: 'footer',
			}],
		}, this);
	},

	getOrderStatusList(order) {
		let payment = [];
		let status = order.status;

		if (order.payment_method == 'card') {
			if (order.payment_info) {
				switch (order.payment_info.status) {
				case 'paid':
					payment = [['done', status == 'new' ? 'active' : 'done', _('Objednávka je zaplacená')]];
					break;
				case 'refunded':
					payment = [['done', status == 'new' ? 'active' : 'done', _('Platba byla refundována')]];
					break;
				case 'new':
					payment = [['card', status == 'new' ? 'active' : 'done', _('Objednávka čeká na platbu'), 'pay-status']];
					break;
				case 'failed':
					payment = [['cross', 'cancel', _('Platba byla neúspěšná'), 'pay-status']];
					break;
				}
			}
		}

		switch (status) {
		case 'new':
			return [
				['done', payment.length == 0 ? 'active' : 'done', _('Objednávku jsme obdrželi')],
				...payment,
				['box', '', _('Objednávka se vyřizuje')],
				['car', '', _('Pití už je na cestě k vám')],
			];
		case 'accepted':
			return [
				['done', 'done', _('Objednávku jsme obdrželi')],
				...payment,
				['box', 'active', _('Objednávka se vyřizuje')],
				['car', '', _('Pití už je na cestě k vám')],
			];
		case 'delivering':
			return [
				['done', 'done', _('Objednávku jsme obdrželi')],
				...payment,
				['done', 'done', _('Objednávka se vyřizuje')],
				['car', 'active', _('Pití už je na cestě k vám')],
			];
		case 'cancelled':
			return [
				['done', 'done', _('Objednávku jsme obdrželi')],
				...payment,
				['cross', 'cancel', _('Objednávku jste zrušili')],
			];
		case 'rejected':
			if (order.status_detail == 'payment-timeout') {
				return [
					['done', 'done', _('Objednávku jsme obdrželi')],
					...payment,
					['cross', 'cancel', _('Objednávka nebyla uhrazena')],
				];
			}

			return [
				['done', 'done', _('Objednávku jsme obdrželi')],
				...payment,
				['done', 'done', _('Objednávka se vyřizuje')],
				['cross', 'cancel', _('Objednávka nebyla doručena z důvodu:')],
			];
		case 'delivered':
			return [
				['done', 'done', _('Objednávku jsme obdrželi')],
				...payment,
				['done', 'done', _('Objednávka se vyřizuje')],
				//['done', 'done', _('Pití už je na cestě k vám')],
				['done', 'active', _('Objednávka byla doručena')],
			];
		default:
			return [
				['cross', 'cancel', _('Neznámý stav')],
			];
		}
	},

	renderPaymentButton(order) {
		let payment_info = order && order.payment_info;
		if (payment_info.redirect_url) {
			// first payment
			this.bodyEl.gwCreateChild({
				className: 'pay-buttons',
				children: [{
					nodeName: 'button',
					className: 'secondary icon-left pay-button',
					children: [Utils.useIcon('card'), {
						className: 'text',
						textContent: _('Zaplatit'),
					}],
					'on:click': ev => {
						location.href = payment_info.redirect_url;
					},
				}],
			});
		} else if (payment_info.status == 'failed' && payment_info.allow_retry) {
			// retry payment
			this.bodyEl.gwCreateChild({
				className: 'pay-buttons',
				children: [{
					nodeName: 'button',
					className: 'secondary icon-left pay-button',
					children: [Utils.useIcon('card'), {
						className: 'text',
						textContent: _('Opakovat platbu'),
					}],
					'on:click': async ev => {
						ev.target.disabled = true;

						try {
							this.doRetryPayment();
						} finally {
							ev.target.disabled = false;
						}
					},
				}],
			});
		}
	},

	async doRetryPayment() {
		try {
			await REST.POST('/api/orders/' + this.secret_key + '/new-payment');
		} catch (ex) {
			/* 409 is returned only when the payment already exists and is waiting */
			if (ex.status != 409) {
				throw ex;
			}
		}

		let order = await REST.GET('/api/orders/' + this.secret_key);
		if (order.payment_info && order.payment_info.redirect_url) {
			location.href = order.payment_info.redirect_url;
		} else {
			location.reload();
		}
	},

	setData(order) {
		this.bodyEl.gwReplaceChildren([{
			nodeName: 'video',
			classList: 'funvid',
			autoplay: true,
			loop: false,
			muted: true,
			playsInline: true,
			src: '/imgs/order/' + Math.floor(1 + Math.random() * 6) + '.mp4',
			'on:click': ev => {
				ev.target.currentTime = 0;
				ev.target.play();
			},
		}, {
			nodeName: 'h1',
			textContent: _('Na zdraví!'),
		}]);

		if (order.messages.length > 0) {
			this.bodyEl.gwCreateChild({
				className: 'messages',
				children: order.messages.map(m => {
					return {
						className: 'message',
						children: [{
							className: 'time',
							textContent: Formats.auto_rel_time(m.ts),
						}, {
							className: 'author',
							textContent: _('Řidič Vám napsal') + ':',
						}, {
							className: 'content',
							textContent: m.content,
						}]
					};
				})
			});
		}

		for (let step of this.getOrderStatusList(order)) {
			this.bodyEl.gwCreateChild({
				className: 'step ' + step[1],
				children: [Utils.useIcon(step[0]), {
					nodeName: 'span',
					textContent: step[2],
				}],
			});

			if (step[3] == 'pay-status') {
				this.renderPaymentButton(order);
			}
		}

		if (['delivered', 'rejected', 'cancelled'].includes(order.status)) {
			let finalNote = _('Těšíme se na Váš další nákup');
			let finalNoteCls;
			if (order.status == 'rejected') {
				if (order.status_detail == 'payment-timeout') {
					finalNote = _('Bohužel jste objednávku kartou neuhradil/a včas a proto byla zrušena');
				} else {
					if (order.status_note) {
						finalNote = order.status_note;
						finalNoteCls = 'warning';
					} else {
						finalNote = _('Velmi nás to mrzí, ale Vaši objednávku nedokážeme v tuto chvíli uspokojit');
					}
				}
			}
					
			this.bodyEl.gwCreateChild({
				nodeName: 'p',
				className: finalNoteCls,
				textContent: finalNote,
			});

			this.bodyEl.gwCreateChild({
				className: 'form-buttons',
				children: [{
					nodeName: 'button',
					className: 'secondary',
					textContent: _('OK'),
					'on:click': ev => Application.pushRoute('/'),
				}],
			});
		}

		if (!['new', 'accepted', 'delivering'].includes(order.status)) {
			this.footerEl.textContent = '';
			return;
		}

		let etaMessage = _('Čas doručení bude upřesněn po přijetí objednávky řidičem');
		let etaShowTime = false;
		if (order.status != 'new' && order.eta) {
			etaMessage = _('Předpokládaný čas doručení');
			etaShowTime = true;
		} else if (order.status == 'delivering') {
			etaMessage = _('Pracujeme na tom, abychom u Vás byli s Vaší objednávkou co nejdříve!');
		}

		this.footerEl.gwReplaceChildren([{
			className: 'eta',
			children: [{
				nodeName: 'p',
				textContent: etaMessage,
			}, {
				':skip': !etaShowTime,
				nodeName: 'p',
				className: 'time',
				textContent: order.eta ? _('do {time}').replace('{time}', Formats.datetime(order.eta)) : '',
			}],
		}, {
			':skip': order.status == 'delivering',
			className: 'cancel',
			children: [{
				nodeName: 'button',
				className: 'tertiary',
				textContent: _('Zrušit objednávku'),
				'on:click': ev => {
					ev.preventDefault();
					this.cancelOrder();
				},
			}],
		}]);
	},

	async cancelOrder() {
		if (!confirm(_('Opravdu chcete zrušit objednávku?'))) {
			return;
		}

		await REST.POST('/api/orders/' + this.secret_key + '/cancel');
		location.reload();
	},
});

// }}}
// {{{ Eshop.InfoScreen

GW.define('Eshop.InfoScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'info-screen',
			children: [{
				className: 'topbar',
				children: [{
					xtype: 'AppLogo',
				}, {
					nodeName: 'button',
					className: 'transparent icon-center',
					children: [Utils.useIcon('menu')],
					'on:click': ev => Application.showHamburgerMenuContent(ev),
				}],
			}, {
				ref: 'bodyEl',
				className: 'body',
			}, {
				ref: 'footerEl',
				className: 'footer',
			}],
		}, this);
	},
});

// }}}
// {{{ Eshop.PaymentReturnScreen

GW.define('Eshop.PaymentReturnScreen', 'Eshop.InfoScreen', {
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			nodeName: 'h1',
			textContent: _('Prosíme vyčkejte'),
		}, {
			nodeName: 'p',
			textContent: _('Čekáme na informace od platební brány...'),
		}, {
			nodeName: 'p',
			className: 'flask-progress',
			children: [Utils.useIcon('logo-red')],
		}], this);
	},

	showError(message) {
		this.bodyEl.gwReplaceChildren([{
			nodeName: 'h1',
			textContent: _('Selhalo přesměrování z platební brány'),
		}, {
			nodeName: 'p',
			textContent: message,
		}], this);
	},

	async activate() {
		const ITERATIONS = 5;

		for (let i = 0; i <= ITERATIONS; i++) {
			try {
				let payment = await REST.GET('/api/payments/' + this.secret_key);
				if (!payment.waiting) {
					Application.replaceRoute('/orders/' + payment.order_key);
					return;
				}
				if (payment.order_key) {
					this.order_key = payment.order_key;
				}
			} catch (ex) {
				if (ex.status) {
					this.showError(ex.message);
					return;
				}

				if (i == ITERATIONS) {
					this.showError(ex.message);
					return;
				}
			}

			await Utils.timeoutPromise(3000);
		}

		this.showError(_('Nepodařilo se získat stav platby'));

		this.bodyEl.gwCreateChild({
			className: 'form-buttons',
			children: [{
				nodeName: 'button',
				className: 'secondary',
				textContent: _('OK'),
				'on:click': ev => {
					if (this.order_key) {
						Application.replaceRoute('/orders/' + this.order_key);
					} else {
						Application.replaceRoute('/');
					}
				}
			}],
		});
	},
});

// }}}

// Data store for eshop:

// {{{ Eshop.DataStore

GW.define('Eshop.DataStore', 'GW.Object', {
	singleton: true,
	stateVersion: 5,

	initObject() {
		DataFetchEngine.registerResources({
			async sync_eshop_data(params, abortSignal) {
				return REST.GET('/api/sync', {since_version: params.version}, {abortSignal});
			},

			async warehouses(params, abortSignal) {
				return REST.GET('/api/warehouses', {
					lon: params.lon,
					lat: params.lat,
				}, {abortSignal});
			},

			async shipping_cost(params, abortSignal) {
				return REST.POST('/api/warehouse/' + params.warehouse + '/shipping-cost', {
					to_location: params.to_location,
				}, {abortSignal});
			},

			async warehouse_stock(params, abortSignal) {
				return REST.GET('/api/warehouse/' + params.id, null, {abortSignal});
			},
		});

		DataFetchEngine.registerScheduler({
			name: 'eshop',
			schedule: this.schedule.bind(this),
		});

		this.reset();
	},

	/*
	 * Clean all locally stored browser data (localStorage, IDB, etc.).
	 */
	cleanup() {
		localStorage.clear();
		this.reset();
	},

	loadLocal() {
		let state = JSON.parse(localStorage.getItem('state'));
		if (!(state instanceof Object) || state.version != this.stateVersion) {
			state = {
				version: this.stateVersion,
				cart: [],
				payment_method: null,
			};
		}

		this.local = state;
	},

	saveLocal() {
		localStorage.setItem('state', JSON.stringify(this.local));
	},

	/*
	 * Re-initialize data store state (this will reload everything from the
	 * server).
	 */
	reset() {
		this.fetch = {}; // DFE fetch status obejcts are put into fetch.something
		this.state = {
			synced: false,
			initial_load_done: false,

			last_sync_version: 0,
			products: [],
			categories: [],
			stock: new Map(),
			catProductCounts: new Map(),
		};
		this.loadLocal();

		DataFetchEngine.schedule();

		this.dispatchChanges(this.changesAll);
	},

	/*
	 * Helper `changes` object that signals that everything was changed.
	 */
	changesAll: {
		anyOf() {
			return true;
		},
	},

	/*
	 * Dispatch changes notification for specific DataStore fields.
	 *
	 * Field is just an arbitrarily named group of objects in the store UI
	 * may be interested in.
	 *
	 * Currently used events:
	 *
	 * - products
	 * - synced
	 * - customer-address
	 * - warehouse
	 * - cart
	 */
	dispatch(...fields) {
		fields = new Set(fields);

		this.dispatchChanges({
			anyOf(...testFields) {
				return testFields.some(f => fields.has(f));
			},
		});
	},

	dispatchChanges(changes) {
		// deliver change notification to the DOM/GW components
		function deliver(el) {
			for (let c of el.children) {
				let cb;
				if (c.$onDataChange) {
					cb = c.$onDataChange.bind(c);
				} else if (c.gwComponent && c.gwComponent.onDataChange) {
					cb = c.gwComponent.onDataChange.bind(c.gwComponent);
				}
				
				if (cb) {
					let res = cb(changes);
					if (res === 'skip-children') {
						continue;
					}
				}

				if (c.children.length > 0) {
					deliver(c);
				}
			}
		}

		if (document.body) {
			deliver(document.body);
		}
	},

	/*
	 * Schedule resource requests according to the current state of the
	 * store.
	 */
	schedule(invocation) {
		let {fetchResource} = DataFetchEngine.Schedulers;
		let cache_time = 120000;

		// if any of resolved resources errored out with 401, terminate
		// the session
		for (let r of invocation.getResolvedResources()) {
			if (!r.ok && r.error.status == 401) {
				//XXX: handle session loss
			}    
		}    

		/*
                let session = this.session = fetchResource(invocation, this.session, {
                        resource: 'session',
                        cache_time,
                });  

                if (session.data_ts == invocation.now) {
			//XXX: update session
                }
		*/

	        // products/categories syncing
                let sync = this.fetch.sync = fetchResource(invocation, this.fetch.sync, {
			resource: 'sync_eshop_data',
			cache_time,
			params: {
				version: this.state.last_sync_version,
			},
                });  

                if (sync.data_ts == invocation.now) {
			let last_ver = this.state.last_sync_version;
			this.syncData(sync.data);
			if (last_ver != this.state.last_sync_version) {
				// if we're not synced yet, schedule next batch
				// immediately
				if (!this.state.synced) {
					DataFetchEngine.schedule();
				}
			} else if (!this.state.synced) {
				this.state.synced = true;
			}
                }

		if (this.local.address && this.local.warehouse) {
			let latlon = this.local.address.location.split(' ');
			let warehouses = this.fetch.warehouses = fetchResource(invocation, this.fetch.warehouses, {
				resource: 'warehouses',
				cache_time,
				params: {
					lat: latlon[0],
					lon: latlon[1],
				},
			});

			if (warehouses.data_ts == invocation.now) {
				this.updateWarehouses(warehouses.data);
			}
		}

		if (this.local.warehouse) {
			let warehouse = this.fetch.warehouse = fetchResource(invocation, this.fetch.warehouse, {
				resource: 'warehouse_stock',
				cache_time,
				params: {
					id: this.local.warehouse.id,
				},
			});

			if (warehouse.data_ts == invocation.now) {
				this.updateWarehouseStock(warehouse.data);
			}
		}

		if (this.local.warehouse && this.local.address && this.local.shipping_cost_needed && !this.local.shipping_cost) {
			let cost = this.fetch.cost = fetchResource(invocation, this.fetch.cost, {
				resource: 'shipping_cost',
				params: {
					warehouse: this.local.warehouse.id,
					to_location: this.local.address.location,
				},
			});

			if (cost.data_ts == invocation.now) {
				this.local.shipping_cost = cost.data;
				this.saveLocal();
				this.dispatch('cart');
			}
		}

		if (this.state.synced && this.fetch.warehouse && this.fetch.warehouse.loaded && !this.state.initial_load_done) {
			this.state.initial_load_done = true;
			this.dispatch('synced');
		}
	},

	syncList(name, updates, tombstones) {
		let changed = new Set(updates.map(u => u.version));
		let prevSize = this.state[name].length;
		let unchanged = this.state[name]
			.filter(i => !tombstones.has(i.version) && !changed.has(i.version));
		let signalChanges = prevSize != unchanged.length || updates.length > 0;
		this.state[name] = unchanged.concat(updates);

		let map = new Map;
		for (let item of this.state[name]) {
			let existing = map.get(item.id);
			if (!existing || existing.version < item.version) {
				map.set(item.id, item);
			}
		}

		this.state[name] = Array.from(map.values());

		let max_update_version = updates.reduce((max, i) => {
			return Math.max(max, i.version);
		}, 0);

		this.state.last_sync_version = Math.max(this.state.last_sync_version, max_update_version);

		if (signalChanges) {
			setTimeout(() => {
				this.dispatch('products');
			}, 0)
		}
	},

	syncData(data) {
		let tombstones = new Set(data.tombstones || []);

		this.syncList('products', data.products, tombstones);
		this.syncList('categories', data.categories, tombstones);
		this.state.last_sync_version = Math.max(this.state.last_sync_version, data.last_tombstone_version || 0);

		this.updateCounts();
	},

	updateCounts() {
		let counts = this.state.catProductCounts = new Map();
		for (let p of this.state.products) {
			if (this.getProductStock(p.id) > 0) {
				counts.set(p.category, (counts.get(p.category) || 0) + 1);

				if (p.favorited) {
					counts.set('fav', (counts.get('fav') || 0) + 1);
				}
			}
		}
	},

	updateWarehouses(warehouses) {
		if (!this.local.warehouse) {
			return;
		}

		if (!warehouses.active[0]) {
			// no warehouse is active anymore
			Application.showMessage({
				paragraphs: [
					_('Vámi vybraný sklad již dnes nerozváží a žádný další sklad není ve Vaší lokalitě k dispozici.'),
				],
				cancelText: _('Rozumím'),
				onCancel() {
					Eshop.DataStore.setWarehouse();
					Eshop.DataStore.closeOrder();
					this.close();
					Application.replaceRoute('/');
				},
			});

			this.setWarehouse();
		} else if (!warehouses.active.find(w => w.id == this.local.warehouse.id)) {
			// selected warehouse is no longer active
			Application.showMessage({
				paragraphs: [
					_('Vámi vybraný sklad již dnes nerozváží. Chcete přejít na nejbližší dostupný sklad ve vzdálenosti {distance}?')
						.replace('{distance}', Formats.distance(warehouses.active[0].distance / 1000)),
				],
				confirmText: _('Ano'),
				cancelText: _('Ne, zkusím to jindy'),
				onConfirm() {
					Eshop.DataStore.setWarehouse(warehouses.active[0]);
					this.close();
					Application.replaceRoute('/');
				},
				onCancel() {
					Eshop.DataStore.setWarehouse();
					Eshop.DataStore.closeOrder();
					this.close();
					Application.replaceRoute('/');
				},
			});
		} else if (warehouses.active[0].id != this.local.warehouse.id && !this.local.skip_closeness_check) {
			// closest active warehouse has changed
			if (warehouses.active[0].distance < this.local.warehouse.distance) {
				// closest active is now closer
				Application.showMessage({
					paragraphs: [
						_('Právě otevřel sklad, který to má k Vám blíže. Chcete přejít na nejbližší dostupný sklad ve vzdálenosti {distance}?')
							.replace('{distance}', Formats.distance(warehouses.active[0].distance / 1000)),
					],
					confirmText: _('Ano'),
					cancelText: _('Ne, chci pokračovat v nákupu'),
					onConfirm() {
						Eshop.DataStore.setWarehouse(warehouses.active[0]);
						this.close();
						Application.replaceRoute('/');
					},
					onCancel() {
						Eshop.DataStore.local.skip_closeness_check = true;
						Eshop.DataStore.saveLocal();
						this.close();
					},
				});
			}
		}
	},

	updateWarehouseStock(warehouse) {
		this.state.stock = new Map(warehouse.stock.map(s => [s.id, s.qty]));
		this.updateCounts();
		this.dispatch('products');
	},

	// reload warehouse status and do product sync immediately
	refreshStockProducts() {
		delete this.fetch.sync;
		delete this.fetch.warehouse;
		delete this.fetch.warehouses;
		DataFetchEngine.schedule();
	},

	// accessors for UI

	isSynced() {
		return this.state.initial_load_done;
	},

	setWarehouse(warehouse) {
		this.local.warehouse = warehouse;
		this.local.skip_closeness_check = false;
		delete this.fetch.warehouse;
		this.state.stock = new Map();
		this.local.shipping_cost_needed = !!warehouse;
		delete this.local.shipping_cost;
		this.local.payment_method = null;
		this.saveLocal();
		this.dispatch('warehouse');
		DataFetchEngine.schedule();
	},

	getWarehouse() {
		return this.local.warehouse;
	},

	getCategories() {
		let counts = this.state.catProductCounts;
		let cats = (this.state.categories || []).filter(c => counts.get(c.id));

		cats.sort((a, b) => a.name.localeCompare(b.name));

		if (counts.get('fav')) {
			cats.unshift({
				id: 'fav',
				name: _('Oblíbené'),
				photoPath: '/imgs/cat-fav.svg',
			});
		}

		cats.unshift({
			id: 'all',
			name: _('Vše'),
			photoPath: '/imgs/cat-all.svg',
		});

		return cats;
	},

	getProducts() {
		let products = (this.state.products || []);

		products.sort((a, b) => a.name.localeCompare(b.name));

		return products.filter(p => this.getProductStock(p.id) > 0);
	},

	getProductStock(id) {
		return this.state.stock.get(id) || 0;
	},

	// customer order

	setCustomerAddress(address) {
		this.local.address = address;
		delete this.fetch.warehouses;
		this.setWarehouse();

		this.saveLocal();
		this.dispatch('customer-address');
	},

	getCustomerAddress() {
		return this.local.address;
	},

	getShippingCost() {
		if (!this.local.shipping_cost) {
			return null;
		}

		return this.local.shipping_cost.shipping_cost;
	},

	getShippingCostKey() {
		if (!this.local.shipping_cost) {
			return null;
		}

		return this.local.shipping_cost.skey;
	},

	getOrderInfo() {
		return this.local.order_info;
	},

	setOrderInfo(data) {
		this.local.order_info = data;

		this.saveLocal();
		this.dispatch('cart');
	},

	canAccess(step) {
		let cart = Eshop.DataStore.getCartOverview();
		let payment_methods = Eshop.DataStore.getAvailablePaymentMethods(cart);
		let payment_method = Eshop.DataStore.getPaymentMethod();
		let payment_method_available = payment_methods.some(m => m.id == payment_method && m.errors.length == 0);
		let has_shipping_cost = this.getShippingCost() != null;
		let cart_empty = cart.items.length == 0;
		let cart_free = cart.total == 0;

		switch (step) {
		case 'checkout2':
			return !cart_empty && has_shipping_cost;
		case 'checkout3':
			return !cart_empty && has_shipping_cost && (payment_method_available || cart_free);
		case 'checkout4':
			return !cart_empty && has_shipping_cost && (payment_method_available || cart_free) && this.getOrderInfo();
		default:
			throw new Error('Invalid canAccess step');
		}
	},

	getAvailablePaymentMethods(cart) {
		let methods = {};
		if (this.local.shipping_cost && this.local.shipping_cost.payment_methods) {
			methods = this.local.shipping_cost.payment_methods;
		}

		function getBlockMessages(type) {
			if (methods[type] && !methods[type].allowed) {
				return methods[type].messages || [];
			}

			return [];
		}

		let cashErrors = getBlockMessages('cash');
		if (cart.limit > 500000) {
			cashErrors.push(_('Platit hotově při převzetí lze pouze u objednávek do výše 500 000 Kč'));
		}

		let cardErrors = getBlockMessages('card');
		if (cart.total > 50000) {
			cardErrors.push(_('Platit kartou online lze pouze u objednávek do výše 50 000 Kč'));
		}

		return [{
			id: 'cash',
			text: _('Hotově při převzetí'),
			icon: 'pay',
			errors: cashErrors,
		}, {
			id: 'card',
			text: _('Kartou online'),
			icon: 'visa',
			errors: cardErrors,
			messages: [
				_('Objednávky placené kartou vyřizujeme přednostně.'),
				_('Při platbě kartou vracíme 5 % z ceny zboží formou slevového voucheru na další nákup.'),
			],
		}];
	},

	setPaymentMethod(method) {
		if (this.local.payment_method == method) {
			return;
		}

		this.local.payment_method = method;

		this.saveLocal();
		this.dispatch('cart');
	},

	getPaymentMethod() {
		return this.local.payment_method;
	},

	setCartItem(product, qty) {
		if (qty <= 0) {
			this.local.cart = this.local.cart.filter(i => {
				return i.product.id != product.id;
			});
		} else {
			let i = this.local.cart.find(i => {
				return i.product.id == product.id;
			});

			if (i) {
				i.qty = qty;
				i.product = product;
			} else {
				this.local.cart.push({
					product,
					qty,
				});
			}
		}

		this.saveLocal();
		this.dispatch('cart');
	},

	setCartItemCheckDeps(product, qty) {
		let failedItems = Eshop.DataStore.getCartItemsFailingConditionalPricing(product, qty);
		if (failedItems.length > 0) {
			new Eshop.ModalConfirmDialog({
				cls: 'product-removal-warning',
				closeable: false,
				promptText: _('Toto zboží lze odebrat jen spolu s {items}. Chcete zboží z košíku odebrat?')
					.replace('{items}', failedItems.map(i => i.product.name).join(', ')),
				onConfirm: () => {
					Eshop.DataStore.setCartItem(product, qty);
					for (let item of failedItems) {
						Eshop.DataStore.setCartItem(item.product, 0);
					}
				},
			});
		} else {
			Eshop.DataStore.setCartItem(product, qty);
		}
	},

	getCartItemQty(id) {
		let i = this.local.cart.find(i => i.product.id == id);

		return i ? i.qty : 0;
	},

	applyDiscountCoupon(code, amount, amount_kind) {
		this.local.coupon = {
			code,
			amount,
			amount_kind,
		};
		this.saveLocal();
		this.dispatch('cart');
	},

	clearDiscountCoupon() {
		this.local.coupon = null;
		this.saveLocal();
		this.dispatch('cart');
	},

	getCartSize() {
		let total = 0;

		for (let i of this.local.cart) {
			total += i.qty;
		}

		return total;
	},

	getCartOverview() {
		let items = this.local.cart.slice();
		let items_total = items.reduce((sum, i) => sum + i.product.price * i.qty, 0);
		let shipping_cost = this.getShippingCost();
		let total = items_total + shipping_cost;
		let discount = 0;

		// NOTE: Keep this in sync with server side code!
		let coupon = this.local.coupon;
		if (coupon && coupon.amount_kind == 'absolute' && coupon.amount > 0) {
			discount = Math.min(total, coupon.amount);
		} else if (coupon && coupon.amount_kind == 'percentage' && coupon.amount > 0 && coupon.amount <= 100) {
			discount = Math.floor(coupon.amount / 100 * total);
		}

		total -= discount;

		items.sort((a, b) => a.product.name.localeCompare(b.product.name));

		let min_order_price = items.reduce((price, i) => Math.max(i.product.min_order_price || 0, price), 0);
		let unconditional_total = items.filter(i => !i.product.min_order_price)
			.reduce((sum, i) => sum + i.product.price * i.qty, 0) + shipping_cost;

		return {
			items,
			items_total,
			shipping_cost,
			total,
			discount,
			coupon_code: coupon ? coupon.code : null,
			// minimum price of the order without VAT (based on
			// ordered items)
			min_order_price,
			unconditional_total,
		};
	},

	getCartItemsFailingConditionalPricing(product, qty) {
		let cart = Eshop.DataStore.getCartOverview();
		let cartQty = Eshop.DataStore.getCartItemQty(product.id);

		/*
		 * If new quantity is greater that the current cart quantity
		 * or this is a conditional product, everything is ok.
		 */
		if (cartQty <= qty || product.min_order_price) {
			return [];
		}

		let price = cart.unconditional_total - (cartQty - qty) * product.price;

		return this.local.cart.filter(i => (i.product.min_order_price || 0) > price);
	},

	getProductIssues(p) {
		let issues = [];
		let current = Eshop.DataStore.getProducts().find(_p => _p.id == p.id);
		let cartQty = Eshop.DataStore.getCartItemQty(p.id);
		let stock = Eshop.DataStore.getProductStock(p.id);

		if (!current || stock == 0) {
			issues.push(_('Produkt již není v nabídce.'));
			return issues;
		} else if (current.price != p.price) {
			issues.push(_('Změnila se cena z {original} na {current}.')
				.replace('{original}', Formats.price(p.price))
				.replace('{current}', Formats.price(current.price))
			);
		}

		if (cartQty > stock) {
			issues.push(_n(cartQty, 'Nelze objednat {n} kus.'), _n(stock, 'Skladem už je pouze {n} kus.'));
		}

		return issues;
	},

	resolveCartProductIssues(p) {
		let current = Eshop.DataStore.getProducts().find(_p => _p.id == p.id);
		let cartQty = Eshop.DataStore.getCartItemQty(p.id);
		let stock = Eshop.DataStore.getProductStock(p.id);

		if (!current || stock == 0) {
			this.setCartItem(p, 0);
			return;
		} else if (current.price != p.price) {
			this.setCartItem(current, cartQty);
		}

		if (cartQty > stock) {
			this.setCartItem(current, stock);
		}
	},

	closeOrder() {
		this.local.cart = [];
		this.local.address = null;
		this.local.coupon = null;
		this.local.payment_method = null;
		this.saveLocal();
		this.dispatch('cart', 'customer-address');
	},
});

// }}}

// Application/routes:

// {{{ Application

Application = new GW.Application({
	async commonRouteHandler(match) {
		//console.log('route', match);

		if (match.route.group == 'public-noaddr') {
			return;
		}
		
		if (!Eshop.DataStore.getCustomerAddress()) {
			Application.show({
				id: 'eshop.landing',
				xtype: 'Eshop.LandingPage',
			});

			return true;
		}

		/*
		if (!Application.session) {
			Application.session = await REST.GET('/api/session');
		}

		if (match.route.group == 'public' && Application.session) {
			Application.replaceRoute('/customer');
			return true;
		}

		if (match.route.group == 'customer' && !Application.session) {
			Application.replaceRoute('/login');
			return true;
		}
		*/
	},

	showMessage(c) {
		c = GW.create(c, 'Eshop.MessageDialog');

		if (Application.isMobileUI()) {
			c.close = function() {
				PopupManager.hide(c);
			};

			PopupManager.show(c);
		} else {
			Application.showOver(c);
		}
	},

	showHamburgerMenuContent(ev) {
		let detail = new Eshop.ShopInfoScreen();

		PopupManager.show(detail, {
			anchorEvent: ev,
		});
	},
});

// }}}
// {{{ Routes

Application.addRoutes([{
	/*
        group: 'public',
        path: '/register',
        async handler({params}) {
		Application.show({
			id: 'pub.register.start',
			xtype: 'Pubweb.RegisterStart',
		});
        }    
}, {
        group: 'public',
        path: '/register/complete/{auth:str}',
        async handler({params, captures}) {
		Application.show({
			id: 'pub.register.complete',
			xtype: 'Pubweb.RegisterComplete',
			auth: captures.auth,
		});
        }    
}, {
        group: 'public',
        path: '/recover-password',
        async handler({params}) {
		Application.show({
			id: 'pub.recoverpw.start',
			xtype: 'Pubweb.RecoverPasswordStart',
		});
        }    
}, {
        group: 'public',
        path: '/recover-password/finish',
        async handler({params}) {
		if (!params.get('email')) {
			Application.replaceRoute('/login');
		}

		Application.show({
			id: 'pub.recoverpw.finish',
			xtype: 'Pubweb.RecoverPasswordFinish',
			email: params.get('email'),
		});
        }    
}, {
        group: 'public',
        path: '/login',
        async handler({params}) {
		Application.show({
			id: 'pub.login',
			xtype: 'Pubweb.LoginScreen',
		});
        }
}, {
*/
        group: 'public',
        path: '/cart',
        async handler({params}) {
		Eshop.DataStore.refreshStockProducts();

		Application.show({
			id: 'eshop.checkout1',
			xtype: 'Eshop.CheckoutScreen1',
		});
        }    
}, {
        group: 'public',
        path: '/checkout/2',
        async handler({params}) {
		if (!Eshop.DataStore.canAccess('checkout2')) {
			Application.replaceRoute('/cart');
			return;
		}

		Application.show({
			id: 'eshop.checkout2',
			xtype: 'Eshop.CheckoutScreen2',
		});
        }    
}, {
        group: 'public',
        path: '/checkout/3',
        async handler({params}) {
		if (!Eshop.DataStore.canAccess('checkout3')) {
			Application.replaceRoute('/cart');
			return;
		}

		Application.show({
			id: 'eshop.checkout3',
			xtype: 'Eshop.CheckoutScreen3',
		});
        }    
}, {
        group: 'public',
        path: '/address/switch',
        async handler({params}) {
		let c = Application.show({
			id: 'eshop.landing',
			xtype: 'Eshop.LandingPage',
		});
        }    
}, {
        group: 'public',
        path: '/category/{category:str}',
        async handler({params, captures}) {
		let c = Application.show({
			id: 'eshop.home',
			xtype: 'Eshop.HomeScreen',
		});

		c.loadCategory(captures.category);
        }    
}, {
        group: 'public-noaddr',
        path: '/orders/{key:str}',
        async handler({params, captures}) {
		try {
			let order = await REST.GET('/api/orders/' + captures.key);

			let payment_info = order && order.payment_info;
			if (payment_info && payment_info.redirect_url) {
				// is first payment attempt, show step 5
				// screen with no way to return to previous
				// steps
				let c = Application.show({
					id: 'eshop.order.' + captures.key,
					xtype: 'Eshop.CheckoutScreen5',
					secret_key: captures.key,
				});

				c.setData(payment_info.redirect_url);
			} else {
				// is further payment attempt, show regular
				// status
				let c = Application.show({
					id: 'eshop.order.' + captures.key,
					xtype: 'Eshop.OrderStatusScreen',
					secret_key: captures.key,
				});

				c.setData(order);
			}
		} catch (ex) {
			// some error
			let c = Application.show({
				id: 'eshop.order.' + captures.key,
				xtype: 'Eshop.OrderStatusScreen',
				secret_key: captures.key,

				'after:initComponent'() {
					this.bodyEl.gwReplaceChildren([{
						nodeName: 'h1',
						textContent: _('Objednávku nelze načíst!'),
					}, {
						nodeName: 'p',
						textContent: ex.message,
					}]);
				},
			});
		}
        }    
}, {
        group: 'public-noaddr',
        path: '/payment-return/{key:str}',
        async handler({params, captures}) {
		Application.show({
			secret_key: captures.key,
			xtype: 'Eshop.PaymentReturnScreen',
		});
        }    
}, {
        group: 'public',
        path: '/',
        async handler({params}) {
		Application.replaceRoute('/category/all');
        }    
}]);

// }}}
